<template>
  <v-app id="dashboard-owner">
    <!-- Header -->
    <v-app-bar
      app
      :color="$vuetify.theme.dark ? '#1C1C1E' : 'white'"
      flat
      height="64"
      class="px-2"
    >
      <v-container fluid class="d-flex align-center justify-space-between pa-0">
        <!-- Logo e Nome -->
        <div class="d-flex align-center">
          <div class="d-flex align-center mr-3" style="width: 36px; height: 36px; background: linear-gradient(135deg, #FF771C, #F6AB2E); border-radius: 10px; justify-content: center;">
            <v-icon color="white" size="20">mdi-elevation-rise</v-icon>
          </div>
          <div class="d-flex align-center">
            <span class="text-h6 font-weight-bold mr-3" :style="{ color: $vuetify.theme.dark ? '#FFFFFF' : '#1D1D1F', letterSpacing: '-0.02em' }">ElevMent</span>
            <v-chip
              small
              :color="$vuetify.theme.dark ? '#2C2C2E' : '#F5F5F7'"
              :text-color="$vuetify.theme.dark ? '#AEAEB2' : '#86868B'"
              class="font-weight-medium"
              style="border-radius: 6px;"
            >
              Owner
            </v-chip>
          </div>
        </div>

        <!-- Ações do Header -->
        <div class="d-flex align-center">
          <v-btn text @click="goToSettings" style="color: #374151;">
            <v-icon left size="18">mdi-cog-outline</v-icon>
            Configurações
          </v-btn>
          <v-btn text @click="logout" class="ml-1" style="color: #6B7280;">
            <v-icon left size="18">mdi-logout</v-icon>
            Sair
          </v-btn>
        </div>
      </v-container>
    </v-app-bar>

    <!-- Conteúdo Principal -->
    <v-main class="dashboard-main">
      <v-container fluid class="pa-6">
        <!-- Tabs de Navegação -->
        <v-tabs
          v-model="activeTab"
          background-color="transparent"
          class="owner-tabs mb-6"
          slider-color="#111827"
          slider-size="2"
          color="#111827"
        >
          <v-tab>
            <v-icon left small>mdi-view-dashboard-outline</v-icon>
            Visão Geral
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-domain</v-icon>
            Tenants
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-chart-line-variant</v-icon>
            Engajamento
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-currency-usd</v-icon>
            Financeiro
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-bell-outline</v-icon>
            Alertas
            <v-badge
              v-if="alertCount > 0"
              :content="alertCount"
              color="red"
              inline
              class="ml-2"
            />
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-calendar-check-outline</v-icon>
            Demos
            <v-badge
              v-if="demoPendingCount > 0"
              :content="demoPendingCount"
              color="orange"
              inline
              class="ml-2"
            />
          </v-tab>
        </v-tabs>

        <v-divider class="mb-6" />

        <!-- Tab Content -->
        <v-tabs-items v-model="activeTab">
          <!-- ==================== -->
          <!-- TAB: VISÃO GERAL     -->
          <!-- ==================== -->
          <v-tab-item>
            <!-- ===== SAÚDE GERAL ===== -->
            <div class="text-overline font-weight-bold grey--text text--darken-2 mb-3">SAÚDE GERAL</div>
            <v-row class="mb-2">
              <!-- Tenants Ativos -->
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="green lighten-4" size="48" class="mr-4">
                      <v-icon color="green darken-1">mdi-domain</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Tenants Ativos</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ stats.activeTenants }}</div>
                      <div class="text-caption green--text font-weight-medium">+{{ tenantsThisMonth }} este mês</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- Usuários Total -->
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="teal lighten-4" size="48" class="mr-4">
                      <v-icon color="teal darken-1">mdi-account-group</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Usuários Total</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ stats.totalUsers }}</div>
                      <div class="text-caption green--text font-weight-medium">+{{ usersThisMonth }} este mês</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- Risco de Churn -->
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card" :style="churnRiskCount > 0 ? 'background-color: #FFF5F5;' : ''">
                  <div class="d-flex align-center">
                    <v-avatar color="red lighten-4" size="48" class="mr-4">
                      <v-icon color="red darken-1">mdi-alert-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Risco de Churn</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ churnRiskCount }}</div>
                      <div class="text-caption red--text text--darken-1 font-weight-medium">sem login há 30d+</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- MRR -->
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="amber lighten-4" size="48" class="mr-4">
                      <v-icon color="amber darken-3">mdi-currency-usd</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">MRR</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ formatCurrency(totalMrr) }}</div>
                      <div class="text-caption grey--text font-weight-medium">{{ payingTenantsCount }} pagantes</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- ===== CONVERSÃO & TRIAL ===== -->
            <div class="text-overline font-weight-bold grey--text text--darken-2 mb-3 mt-6">CONVERSÃO &amp; TRIAL</div>
            <v-row class="mb-2">
              <!-- Em Trial -->
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="blue-grey lighten-4" size="48" class="mr-4">
                      <v-icon color="blue-grey darken-1">mdi-clock-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Em Trial</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ conversionData ? conversionData.trialStarted : trialTenantsCount }}</div>
                      <div class="text-caption grey--text font-weight-medium">{{ expiringTrialNote }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- Taxa de Conversão -->
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="indigo lighten-4" size="48" class="mr-4">
                      <v-icon color="indigo darken-1">mdi-trending-up</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Taxa de Conversão</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ conversionRate }}</div>
                      <div class="text-caption grey--text font-weight-medium">{{ conversionNote }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- Demos Agendadas -->
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card" :style="demoScheduledCount > 0 ? 'background-color: #FFFBEB;' : ''">
                  <div class="d-flex align-center">
                    <v-avatar color="orange lighten-4" size="48" class="mr-4">
                      <v-icon color="orange darken-2">mdi-calendar-check-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Demos Agendadas</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ demoScheduledCount }}</div>
                      <div class="text-caption orange--text text--darken-2 font-weight-medium">{{ demosNote }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- Alertas Abertos -->
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card" :style="alertsOpenCount > 0 ? 'background-color: #FFF5F5;' : ''">
                  <div class="d-flex align-center">
                    <v-avatar color="red lighten-4" size="48" class="mr-4">
                      <v-icon color="red darken-1">mdi-bell-alert-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Alertas Abertos</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ alertsOpenCount }}</div>
                      <div class="text-caption red--text text--darken-1 font-weight-medium">{{ alertsCriticalCount }} críticos</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- ===== Tenants em risco + Funil ===== -->
            <v-row class="mt-6">
              <!-- Tenants em risco de churn -->
              <v-col cols="12" md="6">
                <v-card outlined rounded="lg" class="pa-5">
                  <div class="d-flex align-center mb-4">
                    <v-icon small color="red darken-1" class="mr-2">mdi-alert-outline</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Tenants em risco de churn</span>
                  </div>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left text-caption">Tenant</th>
                          <th class="text-left text-caption">Último acesso</th>
                          <th class="text-center text-caption">Usuários</th>
                          <th class="text-center text-caption">Situação</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(t, i) in churnTenants" :key="i">
                          <td class="py-2">
                            <div class="d-flex align-center">
                              <div :style="`width:8px;height:8px;border-radius:50%;background:${getChurnDotColor(t.status)};margin-right:8px;`"></div>
                              <span class="text-body-2 font-weight-medium">{{ t.name }}</span>
                            </div>
                          </td>
                          <td class="text-body-2 grey--text">{{ t.lastAccess }}</td>
                          <td class="text-center text-body-2">{{ t.users }}</td>
                          <td class="text-center">
                            <v-chip x-small :color="getChurnChipColor(t.status)" :dark="t.status === 'Crítico'" label>
                              {{ t.status }}
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-col>

              <!-- Funil de conversão -->
              <v-col cols="12" md="6">
                <v-card outlined rounded="lg" class="pa-5">
                  <div class="d-flex align-center mb-4">
                    <v-icon small color="teal darken-1" class="mr-2">mdi-chart-timeline-variant-shimmer</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Funil de conversão</span>
                  </div>
                  <div v-for="(f, i) in funnelData" :key="i" class="mb-3">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <span class="text-body-2 grey--text text--darken-2">{{ f.label }}</span>
                      <span class="text-body-2 font-weight-bold">{{ f.value }}</span>
                    </div>
                    <v-progress-linear
                      :value="funnelMax > 0 ? (f.value / funnelMax) * 100 : 0"
                      :color="f.color"
                      height="10"
                      rounded
                      background-color="grey lighten-3"
                    />
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- ===== Score de saúde + Atividade recente ===== -->
            <v-row class="mt-2">
              <!-- Score de saúde por tenant -->
              <v-col cols="12" md="6">
                <v-card outlined rounded="lg" class="pa-5">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="orange lighten-4" size="32" class="mr-2">
                      <v-icon small color="orange darken-2">mdi-chart-bar</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Score de saúde por tenant</span>
                  </div>
                  <div v-for="(s, i) in healthScores" :key="i" class="mb-3">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <div class="d-flex align-center">
                        <div :style="`width:8px;height:8px;border-radius:50%;background:${getHealthColor(s.score)};margin-right:8px;`"></div>
                        <span class="text-body-2">{{ s.name }}</span>
                      </div>
                      <span class="text-body-2 font-weight-bold">{{ s.score }}</span>
                    </div>
                    <v-progress-linear
                      :value="s.score"
                      :color="getHealthColor(s.score)"
                      height="8"
                      rounded
                      background-color="grey lighten-3"
                    />
                  </div>
                </v-card>
              </v-col>

              <!-- Atividade recente -->
              <v-col cols="12" md="6">
                <v-card outlined rounded="lg" class="pa-5">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="purple lighten-4" size="32" class="mr-2">
                      <v-icon small color="purple darken-1">mdi-lightning-bolt</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Atividade recente</span>
                  </div>
                  <v-list dense class="pa-0">
                    <v-list-item v-for="(a, i) in recentActivity" :key="i" class="px-0">
                      <v-list-item-icon class="mr-3 my-auto">
                        <div :style="`width:8px;height:8px;border-radius:50%;background:${a.color};`"></div>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-2">{{ a.text }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action class="my-auto">
                        <span class="text-caption" :class="a.timeColor || 'grey--text'">{{ a.time }}</span>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>

            <!-- ===== Classificação de Clientes ===== -->
            <v-row class="mt-2">
              <v-col cols="12">
                <v-card outlined rounded="lg" class="pa-5">
                  <div class="d-flex align-center justify-space-between mb-5">
                    <div class="d-flex align-center">
                      <v-avatar color="amber lighten-4" size="32" class="mr-2">
                        <v-icon small color="amber darken-3">mdi-crown</v-icon>
                      </v-avatar>
                      <span class="text-subtitle-1 font-weight-bold">Classificação de Clientes</span>
                    </div>
                    <span class="text-caption grey--text">Por faixa de MRR</span>
                  </div>
                  <v-row>
                    <v-col cols="12" md="4" v-for="(tier, ti) in clientTiers" :key="ti">
                      <v-card outlined rounded="lg" class="pa-4" :style="`border-left: 3px solid ${tier.borderColor};`">
                        <div class="d-flex align-center justify-space-between mb-3">
                          <span class="text-subtitle-2 font-weight-bold" :style="`color:${tier.borderColor};`">{{ tier.label }}</span>
                          <span class="text-caption grey--text">{{ tier.range }}</span>
                        </div>
                        <div v-for="(c, ci) in tier.clients" :key="ci" class="d-flex align-center justify-space-between mb-2">
                          <div class="d-flex align-center">
                            <div :style="`width:6px;height:6px;border-radius:50%;background:${tier.borderColor};margin-right:8px;`"></div>
                            <span class="text-body-2">{{ c.name }}</span>
                          </div>
                          <div>
                            <span class="text-caption grey--text mr-2">{{ c.users }} usr</span>
                            <span class="text-body-2 font-weight-bold">{{ formatCurrency(c.mrr) }}</span>
                          </div>
                        </div>
                        <v-divider class="my-2" />
                        <div class="d-flex align-center justify-space-between">
                          <span class="text-caption grey--text">{{ tier.clients.length }} clientes</span>
                          <span class="text-caption font-weight-bold" :style="`color:${tier.borderColor};`">{{ tier.percentage }}%</span>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>

            <!-- ===== Gráficos: Tenants por Mês + Usuários por Tenant ===== -->
            <v-row class="mt-2">
              <!-- Tenants por Mês -->
              <v-col cols="12" md="7">
                <v-card outlined rounded="lg" class="pa-5">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="orange lighten-4" size="40" class="mr-3">
                      <v-icon color="orange darken-2">mdi-chart-bar</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Tenants por Mês</span>
                  </div>
                  <div v-if="loadingCharts" class="text-center py-12">
                    <v-progress-circular indeterminate color="green" />
                  </div>
                  <bar-chart
                    v-else
                    :chart-data="tenantsChartData"
                    :options="tenantsChartOptions"
                    :height="300"
                  />
                </v-card>
              </v-col>
              <!-- Usuários por Tenant -->
              <v-col cols="12" md="5">
                <v-card outlined rounded="lg" class="pa-5">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="teal lighten-4" size="40" class="mr-3">
                      <v-icon color="teal darken-1">mdi-account-group</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Usuários por Tenant</span>
                  </div>
                  <div v-if="loadingCharts" class="text-center py-12">
                    <v-progress-circular indeterminate color="teal" />
                  </div>
                  <div v-else>
                    <doughnut-chart
                      :chart-data="usersChartData"
                      :options="usersChartOptions"
                      :height="220"
                    />
                    <v-list dense class="mt-3">
                      <v-list-item
                        v-for="(item, index) in mergedUsersByTenant"
                        :key="index"
                        dense
                        class="clickable-item px-0"
                        @click="goToTenantByName(item.tenantName)"
                      >
                        <v-list-item-avatar size="12" class="mr-3 my-0">
                          <div :style="`background-color: ${chartColors[index % chartColors.length]}; width: 12px; height: 12px; border-radius: 50%;`" />
                        </v-list-item-avatar>
                        <v-list-item-content class="py-1">
                          <v-list-item-title class="text-body-2">{{ item.tenantName }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="my-0">
                          <span class="text-body-2 font-weight-bold">{{ item.userCount }}</span>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- ==================== -->
          <!-- TAB: TENANTS          -->
          <!-- ==================== -->
          <v-tab-item>
            <!-- Header da Aba -->
            <div class="d-flex align-center justify-space-between mb-6">
              <div>
                <h2 class="text-h5 font-weight-bold">Gestão de Tenants</h2>
                <p class="text-body-2 grey--text mt-1 mb-0">Gerencie todos os tenants da plataforma</p>
              </div>
              <div class="d-flex align-center" style="gap: 8px;">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      outlined
                      rounded
                      color="grey darken-1"
                      v-bind="attrs"
                      v-on="on"
                      :loading="syncingMetadata"
                      :disabled="syncingMetadata"
                      @click="syncMetadata"
                    >
                      <v-icon left small>mdi-sync</v-icon>
                      Sincronizar
                    </v-btn>
                  </template>
                  <span>Força sincronização dos dados dos tenants</span>
                </v-tooltip>
                <v-btn
                  color="success"
                  rounded
                  @click="showNewTenantDialog = true"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Novo Tenant
                </v-btn>
              </div>
            </div>

            <!-- RESUMO KPIs -->
            <div class="text-overline font-weight-bold grey--text text--darken-1 mb-3" style="letter-spacing: 1.5px;">RESUMO</div>
            <v-row class="mb-6">
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="blue lighten-4" size="48" class="mr-4">
                      <v-icon color="blue darken-2">mdi-domain</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Total de Tenants</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ tenantCards.length }}</div>
                      <div class="text-caption green--text font-weight-medium">+{{ tenantsThisMonth }} este mês</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card" style="background-color: #f0faf0;">
                  <div class="d-flex align-center">
                    <v-avatar color="green lighten-4" size="48" class="mr-4">
                      <v-icon color="green darken-2">mdi-check-circle</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Ativos (últimos 7D)</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ activeLast7dCount }}</div>
                      <div class="text-caption grey--text font-weight-medium">{{ tenantCards.length ? Math.round(activeLast7dCount / tenantCards.length * 100) : 0 }}% do total</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card" style="background-color: #fff5f5;">
                  <div class="d-flex align-center">
                    <v-avatar color="red lighten-4" size="48" class="mr-4">
                      <v-icon color="red darken-2">mdi-alert-circle</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Inativos (30D+)</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ inactive30dCount }}</div>
                      <div class="text-caption red--text font-weight-medium">ação necessária</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card" style="background-color: #fffbf0;">
                  <div class="d-flex align-center">
                    <v-avatar color="amber lighten-4" size="48" class="mr-4">
                      <v-icon color="amber darken-3">mdi-account-clock</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Onboarding</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ onboardingTenantCount }}</div>
                      <div class="text-caption grey--text font-weight-medium">primeiros acessos</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- Filtros + Busca -->
            <div class="d-flex align-center flex-wrap mb-5" style="gap: 8px;">
              <v-chip
                :color="tenantFilter === 'all' ? 'primary' : undefined"
                :outlined="tenantFilter !== 'all'"
                :dark="tenantFilter === 'all'"
                small
                class="font-weight-medium"
                @click="tenantFilter = 'all'"
              >
                Todos ({{ tenantCards.length }})
              </v-chip>
              <v-chip
                :color="tenantFilter === 'active' ? 'green' : undefined"
                :outlined="tenantFilter !== 'active'"
                :dark="tenantFilter === 'active'"
                small
                class="font-weight-medium"
                @click="tenantFilter = 'active'"
              >
                Ativos ({{ tenantCardsByStatus.active }})
              </v-chip>
              <v-chip
                :color="tenantFilter === 'risk' ? 'orange' : undefined"
                :outlined="tenantFilter !== 'risk'"
                :dark="tenantFilter === 'risk'"
                small
                class="font-weight-medium"
                @click="tenantFilter = 'risk'"
              >
                Em risco ({{ tenantCardsByStatus.risk }})
              </v-chip>
              <v-chip
                :color="tenantFilter === 'inactive' ? 'red' : undefined"
                :outlined="tenantFilter !== 'inactive'"
                :dark="tenantFilter === 'inactive'"
                small
                class="font-weight-medium"
                @click="tenantFilter = 'inactive'"
              >
                Inativos ({{ tenantCardsByStatus.inactive }})
              </v-chip>
              <v-chip
                :color="tenantFilter === 'onboarding' ? 'amber darken-2' : undefined"
                :outlined="tenantFilter !== 'onboarding'"
                :dark="tenantFilter === 'onboarding'"
                small
                class="font-weight-medium"
                @click="tenantFilter = 'onboarding'"
              >
                Onboarding ({{ tenantCardsByStatus.onboarding }})
              </v-chip>

              <v-spacer />

              <v-text-field
                v-model="tenantSearch"
                placeholder="Buscar tenant..."
                prepend-inner-icon="mdi-magnify"
                dense
                outlined
                hide-details
                clearable
                style="max-width: 260px;"
                class="tenant-search-field"
              />
            </div>

            <!-- Grid de Cards de Tenants -->
            <v-row>
              <v-col
                v-for="card in filteredTenantCards"
                :key="card.id"
                cols="12"
                sm="6"
                md="4"
              >
                <v-card
                  outlined
                  rounded="lg"
                  class="pa-4 tenant-card"
                  :class="{
                    'tenant-card--risk': card.cardStatus === 'Em risco',
                    'tenant-card--critical': card.cardStatus === 'Crítico',
                    'tenant-card--inactive': card.cardStatus === 'Inativo',
                  }"
                  @click="viewTenant(card)"
                  style="cursor: pointer; transition: all 0.2s;"
                  hover
                >
                  <!-- Header: Avatar + Nome + Status -->
                  <div class="d-flex align-center mb-3">
                    <v-avatar
                      v-if="card.avatarUrl"
                      size="44"
                      class="mr-3"
                    >
                      <v-img :src="card.avatarUrl" alt="logo" contain />
                    </v-avatar>
                    <v-avatar
                      v-else
                      :color="getTenantColor(card.name)"
                      size="44"
                      class="mr-3"
                    >
                      <span class="white--text text-body-2 font-weight-bold">
                        {{ getTenantInitials(card.name) }}
                      </span>
                    </v-avatar>

                    <div class="flex-grow-1" style="min-width: 0;">
                      <div class="text-subtitle-2 font-weight-bold text-truncate">{{ card.name }}</div>
                      <div class="text-caption grey--text">Criado em {{ formatDate(card.provisionedAt) }}</div>
                    </div>

                    <v-chip
                      x-small
                      :color="getTenantCardStatusColor(card.cardStatus)"
                      :text-color="getTenantCardStatusTextColor(card.cardStatus)"
                      class="font-weight-bold ml-2"
                    >
                      {{ card.cardStatus }}
                    </v-chip>
                  </div>

                  <!-- Stats: Usuários, Sessões, Último Acesso -->
                  <v-row dense class="mb-3">
                    <v-col cols="4">
                      <div class="text-center pa-2 rounded" style="background: #f5f5f5;">
                        <div class="text-h6 font-weight-bold" :class="card.userCount > 50 ? 'red--text' : ''">{{ card.userCount }}</div>
                        <div class="text-caption grey--text">usuários</div>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div class="text-center pa-2 rounded" style="background: #f5f5f5;">
                        <div class="text-h6 font-weight-bold" :class="card.sessions != null && card.sessions === 0 ? 'grey--text' : card.sessions > 10 ? 'green--text' : ''">{{ card.sessions != null ? card.sessions : '—' }}</div>
                        <div class="text-caption grey--text">sessões</div>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div class="text-center pa-2 rounded" style="background: #f5f5f5;">
                        <div class="text-h6 font-weight-bold" :class="card.lastAccessDays > 15 ? 'red--text' : card.lastAccessDays <= 1 ? 'green--text' : ''" style="font-size: 0.9rem !important;">{{ card.lastAccessLabel }}</div>
                        <div class="text-caption grey--text">último acesso</div>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- Health Bar -->
                  <div class="d-flex align-center">
                    <span class="text-caption grey--text mr-2 font-weight-medium">Saúde</span>
                    <v-progress-linear
                      :value="card.healthScore"
                      :color="card.healthScore >= 70 ? 'green' : card.healthScore >= 40 ? 'orange' : 'red'"
                      rounded
                      height="8"
                      class="flex-grow-1 mr-2"
                      style="border-radius: 4px;"
                    />
                    <span
                      class="text-caption font-weight-bold"
                      :class="card.healthScore >= 70 ? 'green--text' : card.healthScore >= 40 ? 'orange--text' : 'red--text'"
                    >
                      {{ card.healthScore }}
                    </span>
                  </div>

                  <!-- Menu de ações -->
                  <div class="tenant-card-actions" style="position: absolute; top: 8px; right: 8px;">
                    <v-menu offset-y left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon x-small v-bind="attrs" v-on="on" @click.stop color="grey">
                          <v-icon small>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item @click.stop="viewTenant(card)">
                          <v-list-item-icon><v-icon small>mdi-eye</v-icon></v-list-item-icon>
                          <v-list-item-title>Ver Detalhes</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click.stop="editTenant(card)">
                          <v-list-item-icon><v-icon small>mdi-pencil</v-icon></v-list-item-icon>
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="card.inviteStatus === 'PENDING' || card.inviteStatus === 'EXPIRED'" @click.stop="resendInvite(card)">
                          <v-list-item-icon><v-icon small color="success">mdi-send</v-icon></v-list-item-icon>
                          <v-list-item-title>Reenviar Convite</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click.stop="toggleTenantStatus(card)">
                          <v-list-item-icon>
                            <v-icon small :color="card.status === 'ACTIVE' ? 'red' : 'green'">
                              {{ card.status === 'ACTIVE' ? 'mdi-cancel' : 'mdi-check-circle' }}
                            </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>{{ card.status === 'ACTIVE' ? 'Suspender' : 'Ativar' }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-card>
              </v-col>

              <!-- Empty state -->
              <v-col v-if="filteredTenantCards.length === 0" cols="12">
                <div class="text-center py-10">
                  <v-icon size="64" color="grey lighten-2">mdi-domain-off</v-icon>
                  <p class="text-body-1 grey--text mt-3 mb-0">Nenhum tenant encontrado</p>
                  <p class="text-caption grey--text">Tente ajustar os filtros ou o termo de busca</p>
                </div>
              </v-col>
            </v-row>

            <!-- Dialog: Novo Tenant -->
            <v-dialog v-model="showNewTenantDialog" max-width="560" persistent>
              <v-card rounded="lg">
                <v-card-title class="d-flex align-center justify-space-between pb-1">
                  <div class="d-flex align-center">
                    <v-icon color="green darken-2" class="mr-2">mdi-domain</v-icon>
                    <span class="text-h6 font-weight-bold">Novo Tenant</span>
                    <span v-if="newTenantStep === 2" class="ml-3 text-caption grey--text"> - Passo 2: Logo</span>
                  </div>
                  <v-btn icon @click="closeNewTenantDialog">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                <!-- PASSO 1: Dados do Tenant -->
                <v-card-text v-if="newTenantStep === 1" class="pt-2">
                  <p class="text-body-2 grey--text mb-4">
                    Crie um novo tenant e atribua o primeiro usuário administrador.
                  </p>

                  <!-- Dados do Tenant -->
                  <div class="d-flex align-center mb-3">
                    <v-icon small color="green darken-2" class="mr-2">mdi-domain</v-icon>
                    <span class="text-subtitle-2 font-weight-bold">Dados do Tenant</span>
                  </div>

                  <v-text-field
                    v-model="newTenant.name"
                    label="Nome da Empresa *"
                    placeholder="Ex: Acme Corporation"
                    :rules="[v => !!v || 'Nome é obrigatório']"
                    class="mb-4"
                  />

                  <!-- Planos -->
                  <div class="text-subtitle-2 font-weight-bold mb-3">Escolha o Plano</div>
                  <v-row class="mb-3">
                    <v-col cols="4" v-for="plan in planDetails" :key="plan.value">
                      <v-card
                        :outlined="newTenant.plan !== plan.value"
                        :elevation="newTenant.plan === plan.value ? 8 : 0"
                        class="pa-4 text-center cursor-pointer"
                        :class="newTenant.plan === plan.value ? 'plan-selected' : ''"
                        :style="newTenant.plan === plan.value ? 'border-width: 2px; min-height: 170px; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); background: #303F9F !important; color: white !important;' : 'border-width: 2px; min-height: 170px; transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);'"
                        @click="selectPlan(plan.value)"
                        hover
                      >
                        <v-icon :color="newTenant.plan === plan.value ? 'white' : 'indigo'" class="mb-2" size="32">
                          {{ plan.icon }}
                        </v-icon>
                        <div class="text-subtitle-1 font-weight-bold mb-1">{{ plan.name }}</div>
                        <div class="text-caption mb-2 font-weight-bold" :class="newTenant.plan === plan.value ? 'white--text' : 'indigo--text'">
                          {{ plan.users }}
                        </div>
                        <div class="text-caption" :class="newTenant.plan === plan.value ? 'white--text' : 'grey--text text--darken-1'" style="line-height: 1.4;">
                          {{ plan.description }}
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model.number="newTenant.maxUsers"
                        label="Limite de Usuários (opcional)"
                        type="number"
                        :min="planLimits.min"
                        :max="planLimits.max"
                        :hint="planLimits.hint"
                        persistent-hint
                        :rules="[v => !v || (v >= planLimits.min && (planLimits.max ? v <= planLimits.max : true)) || planLimits.error]"
                      />
                    </v-col>
                  </v-row>

                  <v-divider class="my-3" />

                  <!-- Dados da Empresa (companyData) -->
                  <div class="d-flex align-center mb-3">
                    <v-icon small color="blue-grey darken-1" class="mr-2">mdi-office-building-cog</v-icon>
                    <span class="text-subtitle-2 font-weight-bold">Dados da Empresa (Opcional)</span>
                  </div>

                  <v-row dense>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="newTenant.razaoSocial"
                        label="Razão Social"
                        dense
                        class="mb-1"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="newTenant.nomeFantasia"
                        label="Nome Fantasia"
                        dense
                        class="mb-1"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="newTenant.cnpj"
                        label="CNPJ"
                        dense
                        class="mb-1"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="newTenant.setor"
                        label="Setor"
                        dense
                        class="mb-1"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="newTenant.telefone"
                        label="Telefone"
                        dense
                        class="mb-1"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="newTenant.email"
                        label="E-mail da Empresa"
                        dense
                        class="mb-1"
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="newTenant.endereco"
                        label="Endereço"
                        dense
                        class="mb-1"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="newTenant.website"
                        label="Website"
                        dense
                        class="mb-1"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                        v-model="newTenant.porteEmpresa"
                        :items="['MEI', 'ME', 'EPP', 'Média', 'Grande']"
                        label="Porte da Empresa"
                        dense
                        clearable
                        class="mb-1"
                      />
                    </v-col>
                  </v-row>

                  <v-divider class="my-3" />

                  <!-- Primeiro Administrador -->
                  <div class="d-flex align-center mb-1">
                    <v-icon small color="amber darken-2" class="mr-2">mdi-account-star</v-icon>
                    <span class="text-subtitle-2 font-weight-bold">Primeiro Administrador</span>
                  </div>
                  <p class="text-caption grey--text mb-3">
                    Um convite será enviado automaticamente para o e-mail informado.
                  </p>

                  <v-text-field
                    v-model="newTenant.adminName"
                    label="Nome Completo *"
                    placeholder="Ex: João da Silva"
                    :rules="[v => !!v || 'Nome é obrigatório']"
                    class="mb-2"
                  />

                  <v-text-field
                    v-model="newTenant.adminEmail"
                    label="E-mail *"
                    placeholder="joao@empresa.com"
                    :rules="[v => !!v || 'E-mail é obrigatório', v => /.+@.+\..+/.test(v) || 'E-mail inválido']"
                  />

                  <v-divider class="my-4" />

                  <!-- Upload de Logo/Avatar (Novo Fluxo) -->
                  <div class="d-flex align-center mb-3">
                    <v-icon small color="blue darken-2" class="mr-2">mdi-image</v-icon>
                    <span class="text-subtitle-2 font-weight-bold">Logo da Empresa (Opcional)</span>
                  </div>

                  <div v-if="!newTenantAvatarBlob" class="logo-upload-zone elevation-1 rounded pa-6 mb-4 text-center cursor-pointer" @click="$refs.tenantFileInputStep1.click()" @dragover.prevent @drop.prevent="handleTenantFileDrop">
                    <v-icon size="48" color="grey lighten-1" class="mb-2">mdi-cloud-upload-outline</v-icon>
                    <p class="text-body-2 font-weight-medium grey--text text--darken-1 mb-1">
                      Clique ou arraste a imagem da logo
                    </p>
                    <p class="text-caption grey--text mb-0">
                      JPG, PNG ou WebP • Máximo 5MB
                    </p>
                    <input ref="tenantFileInputStep1" type="file" accept="image/*" style="display:none" @change="onTenantFileSelectedStep1" />
                  </div>

                  <div v-else class="d-flex flex-column align-center mb-4">
                    <v-card class="elevation-2 mb-3" style="border-radius: 12px; overflow: hidden; width: 100%; max-width: 300px;">
                      <v-img
                        :src="previewTenantAvatar"
                        height="200"
                        class="d-flex align-center justify-center"
                      />
                    </v-card>
                    <v-btn small text color="blue" @click="removeTenantAvatarStep1">
                      <v-icon small left>mdi-trash-can-outline</v-icon>
                      Remover imagem
                    </v-btn>
                  </div>

                  <!-- Upload Favicon -->
                  <v-divider class="my-4" />
                  <div class="d-flex align-center mb-3">
                    <v-icon small color="blue darken-2" class="mr-2">mdi-star-four-points</v-icon>
                    <span class="text-subtitle-2 font-weight-bold">Favicon / Ícone do Menu (Opcional)</span>
                  </div>
                  <div class="text-caption grey--text mb-3">Este ícone aparecerá no menu lateral (drawer) dos usuários e gestores.</div>

                  <div class="d-flex align-center">
                    <v-avatar
                      :color="newTenantPreviewFavicon ? 'transparent' : 'grey lighten-3'"
                      size="48"
                      class="elevation-1 mr-4"
                      rounded
                    >
                      <v-img
                        v-if="newTenantPreviewFavicon"
                        :src="newTenantPreviewFavicon"
                        alt="Favicon"
                        contain
                      />
                      <v-icon v-else color="grey" size="24">mdi-image-outline</v-icon>
                    </v-avatar>

                    <div class="flex-grow-1">
                      <v-btn
                        small
                        outlined
                        color="primary"
                        @click="$refs.newTenantFaviconInput && $refs.newTenantFaviconInput.click()"
                      >
                        <v-icon small left>mdi-upload</v-icon>
                        {{ newTenantPreviewFavicon ? 'Trocar Favicon' : 'Enviar Favicon' }}
                      </v-btn>
                      <div class="text-caption grey--text mt-1">PNG ou SVG, até 2MB. Recomendado: 64x64px.</div>
                    </div>

                    <v-btn
                      v-if="newTenantPreviewFavicon"
                      icon
                      x-small
                      @click="removeNewTenantFavicon"
                    >
                      <v-icon small color="red">mdi-close</v-icon>
                    </v-btn>

                    <input
                      ref="newTenantFaviconInput"
                      type="file"
                      accept="image/*"
                      style="display: none"
                      @change="onNewTenantFaviconSelected"
                    >
                  </div>
                </v-card-text>

                <!-- Erro de criação -->
                <div v-if="createTenantError" class="px-6 pb-2">
                  <v-alert
                    type="error"
                    dense
                    text
                    dismissible
                    @input="createTenantError = ''"
                  >
                    {{ createTenantError }}
                  </v-alert>
                </div>

                <v-card-actions v-if="newTenantStep === 1" class="px-6 pb-5">
                  <v-spacer />
                  <v-btn
                    text
                    @click="closeNewTenantDialog"
                    :disabled="creatingTenant"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="success"
                    rounded
                    :loading="creatingTenant"
                    :disabled="!isNewTenantValid"
                    @click="createTenant"
                  >
                    <v-icon left>mdi-send</v-icon>
                    Criar e Enviar Convite
                  </v-btn>
                </v-card-actions>

                <!-- PASSO 2: Upload Avatar/Logo -->
                <v-card-text v-if="newTenantStep === 2" class="pt-4 pb-6 text-center">
                  <p class="text-body-1 font-weight-medium mb-2">
                    Tenant criado com sucesso! 🎉
                  </p>
                  <p class="text-body-2 grey--text mb-5">
                    Agora você pode adicionar o logo/avatar da empresa.
                  </p>

                  <div class="d-flex flex-column align-center">
                    <div class="avatar-upload-wrapper position-relative d-inline-block mb-5">
                      <v-avatar
                        :color="previewTenantAvatar ? 'transparent' : (createdTenant && createdTenant.name ? getTenantColor(createdTenant.name) : 'grey')"
                        size="100"
                        class="elevation-2"
                      >
                        <v-progress-circular
                          v-if="uploadingTenantAvatar"
                          :size="50"
                          :width="5"
                          color="primary"
                          indeterminate
                        />
                        <v-img
                          v-else-if="previewTenantAvatar || (createdTenant && createdTenant.avatarUrl)"
                          :src="previewTenantAvatar || createdTenant.avatarUrl"
                        />
                        <span
                          v-else
                          class="white--text text-h3"
                        >
                          {{ createdTenant ? (getTenantInitials(createdTenant.name) || '') : '' }}
                        </span>
                      </v-avatar>

                      <!-- Botão overlay minimalista -->
                      <v-btn
                        fab
                        x-small
                        color="white"
                        class="logo-upload-btn elevation-3"
                        @click="triggerTenantFileInput"
                        :loading="uploadingTenantAvatar"
                        :disabled="uploadingTenantAvatar"
                      >
                        <v-icon small color="primary">mdi-camera</v-icon>
                      </v-btn>

                      <input ref="tenantFileInput" type="file" accept="image/*" style="display:none" @change="onTenantFileSelected" />
                    </div>

                    <div class="d-flex">
                      <v-btn
                        text
                        @click="skipTenantAvatar"
                        :disabled="uploadingTenantAvatar"
                      >
                        Pular por enquanto
                      </v-btn>
                      <v-btn
                        color="primary"
                        depressed
                        class="ml-3"
                        @click="skipTenantAvatar"
                        :disabled="uploadingTenantAvatar"
                      >
                        Concluir
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>

            <!-- Dialog de Crop para Step 1 -->
            <v-dialog v-model="newTenantCropDialogStep1" max-width="600" persistent>
              <v-card rounded="lg">
                <v-card-title class="pb-2">
                  <div>
                    <span class="text-h6 font-weight-bold">Ajustar Logo</span>
                    <p class="text-caption grey--text mt-1 mb-0">Mova e redimensione para enquadrar perfeitamente</p>
                  </div>
                </v-card-title>

                <v-card-text class="pt-4">
                  <div class="text-center mb-4">
                    <img ref="newTenantCropperImageStep1" :src="newTenantImageToCrop" style="max-width: 100%; max-height: 400px;" />
                  </div>
                </v-card-text>

                <v-card-actions class="px-6 pb-4">
                  <v-spacer />
                  <v-btn text @click="cancelNewTenantCropStep1">
                    Cancelar
                  </v-btn>
                  <v-btn color="primary" depressed @click="confirmNewTenantCropStep1">
                    <v-icon left>mdi-check</v-icon>
                    Confirmar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Dialog: Editar Tenant -->
            <v-dialog v-model="showEditTenantDialog" max-width="580" persistent>
              <v-card rounded="lg" class="edit-tenant-dialog">
                <v-card-title class="d-flex align-center justify-space-between pb-3">
                  <span class="text-h6 font-weight-bold">Editar Tenant</span>
                  <v-btn icon small @click="closeEditTenantDialog">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text class="pt-2 pb-4">
                  <!-- Upload Avatar/Logo -->
                  <div class="text-center mb-6">
                    <div class="avatar-upload-wrapper position-relative d-inline-block">
                      <v-avatar
                        :color="editPreviewAvatar ? 'transparent' : (editingTenant ? getTenantColor(editingTenant.name) : 'grey')"
                        size="100"
                        class="elevation-2"
                      >
                        <v-progress-circular
                          v-if="uploadingEditAvatar"
                          :size="50"
                          :width="5"
                          color="primary"
                          indeterminate
                        />
                        <v-img
                          v-else-if="editPreviewAvatar"
                          :src="editPreviewAvatar"
                          alt="Logo"
                        />
                        <span
                          v-else
                          class="white--text text-h3"
                        >
                          {{ editingTenant ? getTenantInitials(editingTenant.name) : '?' }}
                        </span>
                      </v-avatar>

                      <!-- Botão overlay minimalista -->
                      <v-btn
                        fab
                        x-small
                        color="white"
                        class="logo-upload-btn elevation-3"
                        @click="triggerEditFileInput"
                        :loading="uploadingEditAvatar"
                        :disabled="uploadingEditAvatar"
                      >
                        <v-icon small color="primary">mdi-camera</v-icon>
                      </v-btn>

                      <input
                        ref="editFileInput"
                        type="file"
                        accept="image/*"
                        style="display: none"
                        @change="onEditFileSelected"
                      >
                    </div>
                  </div>

                  <!-- Dados do Tenant -->
                  <v-text-field
                    v-model="editTenantData.name"
                    label="Nome da Empresa *"
                    outlined
                    dense
                    class="mb-4"
                  />

                  <div class="text-body-2 font-weight-medium mb-3">Plano</div>
                  <v-row class="mb-4">
                    <v-col cols="4" v-for="plan in planDetails" :key="plan.value">
                      <v-card
                        :outlined="editTenantData.plan !== plan.value"
                        :elevation="editTenantData.plan === plan.value ? 6 : 0"
                        class="pa-3 text-center cursor-pointer"
                        :class="editTenantData.plan === plan.value ? 'plan-selected' : ''"
                        :style="editTenantData.plan === plan.value ? 'border-width: 2px; min-height: 135px; transition: all 0.3s; background: #303F9F !important; color: white !important;' : 'border-width: 2px; min-height: 135px; transition: all 0.3s;'"
                        @click="selectEditPlan(plan.value)"
                        hover
                      >
                        <v-icon :color="editTenantData.plan === plan.value ? 'white' : 'indigo'" class="mb-2" size="26">
                          {{ plan.icon }}
                        </v-icon>
                        <div class="text-body-2 font-weight-bold mb-1">{{ plan.name }}</div>
                        <div class="text-caption" :class="editTenantData.plan === plan.value ? 'white--text' : 'grey--text'">
                          {{ plan.users }}
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>

                  <v-text-field
                    v-model.number="editTenantData.maxUsers"
                    label="Limite de Usuários (opcional)"
                    type="number"
                    outlined
                    dense
                    :min="editPlanLimits.min"
                    :max="editPlanLimits.max"
                    :hint="editPlanLimits.hint"
                    persistent-hint
                  />

                  <!-- Upload Favicon -->
                  <v-divider class="my-5" />
                  <div class="text-body-2 font-weight-medium mb-3">Favicon / Ícone do Menu</div>
                  <div class="text-caption grey--text mb-3">Este ícone aparecerá no menu lateral (drawer) dos usuários e gestores.</div>

                  <div class="d-flex align-center">
                    <v-avatar
                      :color="editPreviewFavicon ? 'transparent' : 'grey lighten-3'"
                      size="48"
                      class="elevation-1 mr-4"
                      rounded
                    >
                      <v-progress-circular
                        v-if="uploadingEditFavicon"
                        :size="24"
                        :width="3"
                        color="primary"
                        indeterminate
                      />
                      <v-img
                        v-else-if="editPreviewFavicon"
                        :src="editPreviewFavicon"
                        alt="Favicon"
                        contain
                      />
                      <v-icon v-else color="grey" size="24">mdi-image-outline</v-icon>
                    </v-avatar>

                    <div class="flex-grow-1">
                      <v-btn
                        small
                        outlined
                        color="primary"
                        @click="$refs.editFaviconInput && $refs.editFaviconInput.click()"
                        :loading="uploadingEditFavicon"
                        :disabled="uploadingEditFavicon"
                      >
                        <v-icon small left>mdi-upload</v-icon>
                        {{ editPreviewFavicon ? 'Trocar Favicon' : 'Enviar Favicon' }}
                      </v-btn>
                      <div class="text-caption grey--text mt-1">PNG ou SVG, até 2MB. Recomendado: 64x64px.</div>
                    </div>

                    <input
                      ref="editFaviconInput"
                      type="file"
                      accept="image/*"
                      style="display: none"
                      @change="onEditFaviconSelected"
                    >
                  </div>
                </v-card-text>

                <v-card-actions class="px-6 pb-4">
                  <v-spacer />
                  <v-btn
                    text
                    @click="closeEditTenantDialog"
                    :disabled="savingTenant"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="primary"
                    depressed
                    :loading="savingTenant"
                    @click="saveTenantEdit"
                    class="px-5"
                  >
                    <v-icon left small>mdi-content-save</v-icon>
                    Salvar Alterações
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Dialog: Crop de Imagem (New Tenant Wizard) -->
            <v-dialog v-model="newTenantCropDialog" max-width="600" persistent>
              <v-card>
                <v-card-title class="text-h5">
                  <v-icon left color="primary">mdi-crop</v-icon>
                  Ajustar Logo do Tenant
                </v-card-title>

                <v-card-text>
                  <div class="crop-container">
                    <div ref="newTenantCropperContainer" style="max-height: 400px;">
                      <img
                        ref="newTenantCropperImage"
                        :src="newTenantImageToCrop"
                        style="max-width: 100%"
                      >
                    </div>
                  </div>

                  <v-alert
                    text
                    color="info"
                    icon="mdi-information"
                    class="mt-4"
                  >
                    <small>
                      Ajuste a área de corte para 1:1 (quadrado). A imagem será redimensionada automaticamente para 500x500px.
                    </small>
                  </v-alert>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    @click="cancelNewTenantCrop"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="uploadingTenantAvatar"
                    @click="confirmNewTenantCrop"
                  >
                    <v-icon left>mdi-check</v-icon>
                    Confirmar e Enviar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Dialog: Crop de Imagem (Edit Mode) -->
            <v-dialog v-model="editCropDialog" max-width="600" persistent>
              <v-card>
                <v-card-title class="text-h5">
                  <v-icon left color="primary">mdi-crop</v-icon>
                  Ajustar Logo do Tenant
                </v-card-title>

                <v-card-text>
                  <div class="crop-container">
                    <div ref="editCropperContainer" style="max-height: 400px;">
                      <img
                        ref="editCropperImage"
                        :src="editImageToCrop"
                        style="max-width: 100%"
                      >
                    </div>
                  </div>

                  <v-alert
                    text
                    color="info"
                    icon="mdi-information"
                    class="mt-4"
                  >
                    <small>
                      Ajuste a área de corte para 1:1 (quadrado). A imagem será redimensionada automaticamente para 500x500px.
                    </small>
                  </v-alert>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    @click="cancelEditCrop"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="uploadingEditAvatar"
                    @click="confirmEditCrop"
                  >
                    <v-icon left>mdi-check</v-icon>
                    Confirmar e Enviar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-tab-item>

          <!-- ==================== -->
          <!-- TAB: ENGAJAMENTO      -->
          <!-- ==================== -->
          <v-tab-item>
            <!-- ROW 1: KPI Cards grandes (2 colunas) -->
            <v-row class="mb-2">
              <v-col cols="12" md="6">
                <v-card outlined rounded="lg" class="pa-5">
                  <div class="d-flex align-center">
                    <v-avatar color="green lighten-4" size="48" class="mr-4">
                      <v-icon color="green darken-2" size="24">mdi-lightning-bolt</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-overline grey--text d-block" style="line-height: 1.2">SESSÕES / DIA</span>
                      <span class="text-h4 font-weight-bold d-block">{{ engSummary.sessionsPerDay }}</span>
                      <span class="text-caption grey--text">{{ engSummary.sessionsPerDayNote }}</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card outlined rounded="lg" class="pa-5">
                  <div class="d-flex align-center">
                    <v-avatar color="orange lighten-4" size="48" class="mr-4">
                      <v-icon color="orange darken-2" size="24">mdi-clock-outline</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-overline grey--text d-block" style="line-height: 1.2">TEMPO MÉDIO / SESSÃO</span>
                      <span class="text-h4 font-weight-bold d-block">{{ engSummary.avgSessionMinutes }}min</span>
                      <span class="text-caption grey--text">{{ engSummary.avgSessionNote }}</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- ROW 2: KPI Cards menores (4 colunas) -->
            <v-row class="mb-2">
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 text-center">
                  <span class="text-overline grey--text d-block" style="line-height: 1.2">TAXA DE RETENÇÃO D7</span>
                  <span class="text-h4 font-weight-bold green--text d-block mt-1">{{ engSummary.retentionD7 }}%</span>
                  <span class="text-caption grey--text">{{ engSummary.retentionD7Note }}</span>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 text-center">
                  <span class="text-overline grey--text d-block" style="line-height: 1.2">TAXA DE RETENÇÃO D30</span>
                  <span class="text-h4 font-weight-bold blue--text d-block mt-1">{{ engSummary.retentionD30 }}%</span>
                  <span class="text-caption grey--text">{{ engSummary.retentionD30Note }}</span>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 text-center">
                  <span class="text-overline grey--text d-block" style="line-height: 1.2">TENANTS INATIVOS (30D)</span>
                  <span class="text-h4 font-weight-bold red--text d-block mt-1">{{ inactive30dCount }}</span>
                  <span class="text-caption red--text text--darken-1">ação necessária</span>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 text-center">
                  <span class="text-overline grey--text d-block" style="line-height: 1.2">STICKINESS (DAU/MAU)</span>
                  <span class="text-h4 font-weight-bold d-block mt-1">{{ engSummary.stickiness }}%</span>
                  <span class="text-caption grey--text">{{ engSummary.stickinessNote }}</span>
                </v-card>
              </v-col>
            </v-row>

            <!-- ROW 3: Sessões por tenant + Funcionalidades mais usadas -->
            <v-row class="mb-2">
              <!-- Sessões por tenant (dados reais do /tenant-activity) -->
              <v-col cols="12" md="7">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center justify-space-between mb-4">
                    <div class="d-flex align-center">
                      <v-avatar color="blue lighten-4" size="40" class="mr-3">
                        <v-icon color="blue darken-2">mdi-monitor-dashboard</v-icon>
                      </v-avatar>
                      <span class="text-subtitle-1 font-weight-bold">Sessões por tenant</span>
                    </div>
                    <v-chip small outlined color="grey">últimos 30 dias</v-chip>
                  </div>

                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Tenant</th>
                          <th class="text-center">Sessões</th>
                          <th class="text-center">Usuários ativos</th>
                          <th class="text-center">Nível</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(row, i) in engagementSessionsTable"
                          :key="i"
                        >
                          <td class="font-weight-medium">{{ row.name }}</td>
                          <td class="text-center">{{ row.sessions }}</td>
                          <td class="text-center">{{ row.activeUsers }}/{{ row.totalUsers }}</td>
                          <td class="text-center">
                            <v-chip
                              x-small
                              :color="row.levelColor"
                              :text-color="row.levelTextColor"
                              class="font-weight-medium"
                            >
                              {{ row.level }}
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-col>

              <!-- Funcionalidades mais usadas (mock) -->
              <v-col cols="12" md="5">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center mb-5">
                    <v-avatar color="purple lighten-4" size="40" class="mr-3">
                      <v-icon color="purple darken-2">mdi-star-outline</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Funcionalidades mais usadas</span>
                  </div>

                  <div
                    v-for="(feat, i) in engFeaturesList"
                    :key="i"
                    class="mb-4"
                  >
                    <div class="d-flex align-center justify-space-between mb-1">
                      <span class="text-body-2 font-weight-medium">
                        <span class="grey--text mr-2">{{ i + 1 }}.</span>{{ feat.name }}
                      </span>
                      <span class="text-caption font-weight-bold">{{ feat.percentage }}%</span>
                    </div>
                    <v-progress-linear
                      :value="feat.percentage"
                      color="deep-purple accent-3"
                      height="8"
                      rounded
                      background-color="grey lighten-3"
                    />
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- ROW 4: NPS — Net Promoter Score -->
            <v-card outlined rounded="lg" class="pa-5 mb-6">
              <div class="d-flex align-center mb-5">
                <v-avatar color="green lighten-4" size="40" class="mr-3">
                  <v-icon color="green darken-2">mdi-emoticon-happy-outline</v-icon>
                </v-avatar>
                <div>
                  <span class="text-subtitle-1 font-weight-bold d-block">NPS — Net Promoter Score</span>
                  <span class="text-caption grey--text">{{ npsData.totalResponses }} respostas de {{ npsData.totalUsers }} usuários ({{ npsData.responseRate }}% taxa de resposta)</span>
                </div>
              </div>

              <v-row>
                <!-- Score grande -->
                <v-col cols="12" md="3" class="d-flex align-center justify-center">
                  <div class="text-center">
                    <div
                      class="d-inline-flex align-center justify-center rounded-circle"
                      style="width: 120px; height: 120px; border: 4px solid #4CAF50"
                    >
                      <span class="text-h3 font-weight-bold green--text">+{{ npsData.score }}</span>
                    </div>
                    <div class="mt-2">
                      <v-chip small color="green lighten-4" text-color="green darken-2" class="font-weight-medium">
                        {{ npsData.label }} — meta: {{ npsData.goal }}+
                      </v-chip>
                    </div>
                    <div class="text-caption grey--text mt-1">
                      <v-icon x-small color="green">mdi-arrow-up</v-icon>
                      {{ npsData.trend }}
                    </div>
                  </div>
                </v-col>

                <!-- Distribuição -->
                <v-col cols="12" md="4">
                  <span class="text-overline grey--text d-block mb-3">DISTRIBUIÇÃO</span>
                  <div class="mb-3">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <span class="text-body-2 font-weight-medium green--text">Promotores</span>
                      <span class="text-body-2 font-weight-bold">{{ npsData.promoters }}%</span>
                    </div>
                    <v-progress-linear :value="npsData.promoters" color="green" height="10" rounded background-color="grey lighten-3" />
                  </div>
                  <div class="mb-3">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <span class="text-body-2 font-weight-medium orange--text">Neutros</span>
                      <span class="text-body-2 font-weight-bold">{{ npsData.neutrals }}%</span>
                    </div>
                    <v-progress-linear :value="npsData.neutrals" color="orange" height="10" rounded background-color="grey lighten-3" />
                  </div>
                  <div>
                    <div class="d-flex align-center justify-space-between mb-1">
                      <span class="text-body-2 font-weight-medium red--text">Detratores</span>
                      <span class="text-body-2 font-weight-bold">{{ npsData.detractors }}%</span>
                    </div>
                    <v-progress-linear :value="npsData.detractors" color="red" height="10" rounded background-color="grey lighten-3" />
                  </div>
                </v-col>

                <!-- Evolução NPS (line chart) -->
                <v-col cols="12" md="5">
                  <span class="text-overline grey--text d-block mb-3">EVOLUÇÃO</span>
                  <line-chart
                    :chart-data="npsEvolutionChartData"
                    :options="npsEvolutionChartOptions"
                    :height="180"
                  />
                </v-col>
              </v-row>
            </v-card>

            <!-- ROW 5: Horários de pico + Segmentos de engajamento + Top usuários -->
            <v-row>
              <!-- Horários de pico -->
              <v-col cols="12" md="4">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="amber lighten-4" size="40" class="mr-3">
                      <v-icon color="amber darken-3">mdi-clock-outline</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Horários de pico</span>
                  </div>

                  <bar-chart
                    :chart-data="peakHoursChartData"
                    :options="peakHoursChartOptions"
                    :height="200"
                  />

                  <div class="text-center mt-3">
                    <v-chip small outlined color="amber darken-2">
                      <v-icon x-small left>mdi-fire</v-icon>
                      Pico de uso: {{ peakHoursLabel }}
                    </v-chip>
                  </div>
                </v-card>
              </v-col>

              <!-- Segmentos de engajamento (dados reais derivados de tenantCards) -->
              <v-col cols="12" md="4">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="teal lighten-4" size="40" class="mr-3">
                      <v-icon color="teal darken-2">mdi-account-group-outline</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Segmentos de engajamento</span>
                  </div>

                  <div
                    v-for="(seg, i) in engagementSegments"
                    :key="i"
                    class="d-flex align-center mb-4"
                  >
                    <v-avatar :color="seg.color + ' lighten-4'" size="36" class="mr-3">
                      <v-icon :color="seg.color + ' darken-2'" size="18">{{ seg.icon }}</v-icon>
                    </v-avatar>
                    <div class="flex-grow-1">
                      <div class="d-flex align-center justify-space-between">
                        <span class="text-body-2 font-weight-bold">{{ seg.label }}</span>
                        <span class="text-body-2 font-weight-bold">{{ seg.count }} tenants</span>
                      </div>
                      <span class="text-caption grey--text">{{ seg.description }}</span>
                    </div>
                  </div>
                </v-card>
              </v-col>

              <!-- Top usuários ativos -->
              <v-col cols="12" md="4">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="indigo lighten-4" size="40" class="mr-3">
                      <v-icon color="indigo darken-2">mdi-trophy-outline</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Top usuários ativos</span>
                  </div>

                  <div
                    v-for="(user, i) in engagementTopUsers"
                    :key="i"
                    class="d-flex align-center mb-4"
                  >
                    <v-avatar :color="['blue', 'green', 'orange', 'purple', 'teal'][i % 5] + ' lighten-4'" size="36" class="mr-3">
                      <span class="font-weight-bold" :class="['blue', 'green', 'orange', 'purple', 'teal'][i % 5] + '--text text--darken-2'" style="font-size: 14px">
                        {{ user.name ? user.name.split(' ').map(n => n[0]).join('') : '?' }}
                      </span>
                    </v-avatar>
                    <div class="flex-grow-1">
                      <span class="text-body-2 font-weight-medium d-block">{{ user.name }}</span>
                      <span class="text-caption grey--text">{{ user.tenant || user.tenantName }}</span>
                    </div>
                    <div class="text-right">
                      <span class="text-body-2 font-weight-bold">{{ user.sessions }}</span>
                      <span class="text-caption grey--text d-block">sessões</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- ==================== -->
          <!-- TAB: FINANCEIRO       -->
          <!-- ==================== -->
          <v-tab-item>
            <!-- RECEITA -->
            <span class="text-overline grey--text text--darken-1 d-block mb-2">RECEITA</span>
            <v-row class="mb-4">
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4">
                  <div class="d-flex align-center">
                    <v-avatar color="green lighten-4" size="44" class="mr-3">
                      <v-icon color="green darken-2">mdi-currency-usd</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-overline grey--text d-block" style="line-height: 1.2">MRR ATUAL</span>
                      <span class="text-h5 font-weight-bold d-block">{{ formatCurrency(totalMrr) }}</span>
                      <span class="text-caption grey--text">{{ payingTenantsCount }} pagantes ativos</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4">
                  <div class="d-flex align-center">
                    <v-avatar color="blue lighten-4" size="44" class="mr-3">
                      <v-icon color="blue darken-2">mdi-chart-timeline-variant</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-overline grey--text d-block" style="line-height: 1.2">ARR PROJETADO</span>
                      <span class="text-h5 font-weight-bold d-block">{{ formatCurrency(totalMrr * 12) }}</span>
                      <span class="text-caption grey--text">baseado no MRR atual</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4">
                  <div class="d-flex align-center">
                    <v-avatar color="amber lighten-4" size="44" class="mr-3">
                      <v-icon color="amber darken-3">mdi-card-text-outline</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-overline grey--text d-block" style="line-height: 1.2">TICKET MÉDIO</span>
                      <span class="text-h5 font-weight-bold d-block">{{ finTicketMedio }}</span>
                      <span class="text-caption grey--text">{{ payingTenantsCount > 0 ? 'por tenant pagante' : 'dados insuficientes' }}</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4">
                  <div class="d-flex align-center">
                    <v-avatar color="purple lighten-4" size="44" class="mr-3">
                      <v-icon color="purple darken-2">mdi-chart-box-outline</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-overline grey--text d-block" style="line-height: 1.2">LTV ESTIMADO</span>
                      <span class="text-h5 font-weight-bold d-block">{{ finLtvEstimado }}</span>
                      <span class="text-caption grey--text">{{ finHealthData ? 'média ponderada' : 'necessita histórico' }}</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- SAÚDE FINANCEIRA -->
            <span class="text-overline grey--text text--darken-1 d-block mb-2">SAÚDE FINANCEIRA</span>
            <v-row class="mb-4">
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4">
                  <div class="d-flex align-center">
                    <v-avatar color="red lighten-4" size="44" class="mr-3">
                      <v-icon color="red darken-1">mdi-chart-line-variant</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-overline grey--text d-block" style="line-height: 1.2">CHURN RATE</span>
                      <span class="text-h5 font-weight-bold d-block">{{ finHealthData ? finHealthData.churnRate + '%' : '—' }}</span>
                      <span class="text-caption" :class="finHealthData && finHealthData.churnRate < 5 ? 'green--text' : 'red--text'">meta: &lt; 5%</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4">
                  <div class="d-flex align-center">
                    <v-avatar color="orange lighten-4" size="44" class="mr-3">
                      <v-icon color="orange darken-2">mdi-alert-outline</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-overline grey--text d-block" style="line-height: 1.2">INADIMPLÊNCIA</span>
                      <span class="text-h5 font-weight-bold d-block">{{ finHealthData ? finHealthData.overdueCount : '—' }}</span>
                      <span class="text-caption orange--text">{{ finHealthData && finHealthData.overdueAmount > 0 ? formatCurrency(finHealthData.overdueAmount) + ' em aberto' : '' }}</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4">
                  <div class="d-flex align-center">
                    <v-avatar color="blue lighten-4" size="44" class="mr-3">
                      <v-icon color="blue darken-2">mdi-target</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-overline grey--text d-block" style="line-height: 1.2">TAXA DE CONVERSÃO</span>
                      <span class="text-h5 font-weight-bold d-block">{{ conversionRate }}</span>
                      <span class="text-caption grey--text">trial → pagante</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" lg="3">
                <v-card outlined rounded="lg" class="pa-4">
                  <div class="d-flex align-center">
                    <v-avatar color="grey lighten-3" size="44" class="mr-3">
                      <v-icon color="grey darken-2">mdi-cash-minus</v-icon>
                    </v-avatar>
                    <div>
                      <span class="text-overline grey--text d-block" style="line-height: 1.2">NET REVENUE CHURN</span>
                      <span class="text-h5 font-weight-bold d-block">{{ finHealthData ? finHealthData.netRevenueChurn + '%' : '—' }}</span>
                      <span class="text-caption grey--text">{{ finHealthData ? '' : 'sem dados suficientes' }}</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- Evolução do MRR + Projeção   &   Churn Rate Mensal -->
            <v-row class="mb-6">
              <v-col cols="12" md="7">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="green lighten-4" size="40" class="mr-3">
                      <v-icon color="green darken-2">mdi-chart-timeline-variant</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Evolução do MRR + Projeção</span>
                  </div>
                  <line-chart
                    :chart-data="finMrrProjectionChartData"
                    :options="finMrrProjectionChartOptions"
                    :height="300"
                  />
                </v-card>
              </v-col>
              <v-col cols="12" md="5">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="red lighten-4" size="40" class="mr-3">
                      <v-icon color="red darken-1">mdi-chart-line-variant</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Churn Rate Mensal</span>
                  </div>
                  <bar-chart
                    :chart-data="finChurnBarChartData"
                    :options="finChurnBarChartOptions"
                    :height="300"
                  />
                </v-card>
              </v-col>
            </v-row>

            <!-- Receita por tenant + Distribuição por plano -->
            <v-row class="mb-6">
              <v-col cols="12" md="7">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="green lighten-4" size="40" class="mr-3">
                      <v-icon color="green darken-2">mdi-cash-multiple</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Receita por tenant</span>
                  </div>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Tenant</th>
                          <th class="text-left">Plano</th>
                          <th class="text-left">MRR</th>
                          <th class="text-left">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(row, i) in finRevenueByTenantTable" :key="i">
                          <td class="font-weight-medium blue--text text--darken-2">{{ row.name }}</td>
                          <td>{{ row.plan }}</td>
                          <td class="font-weight-medium">{{ formatCurrency(row.mrr) }}</td>
                          <td>
                            <v-chip
                              x-small
                              :color="row.statusColor"
                              :text-color="row.statusTextColor"
                              class="font-weight-medium"
                            >
                              {{ row.statusLabel }}
                            </v-chip>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-col>
              <v-col cols="12" md="5">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center mb-4">
                    <v-avatar color="blue lighten-4" size="40" class="mr-3">
                      <v-icon color="blue darken-2">mdi-chart-donut</v-icon>
                    </v-avatar>
                    <span class="text-subtitle-1 font-weight-bold">Distribuição por plano</span>
                  </div>
                  <div class="d-flex align-center justify-center" style="min-height: 200px">
                    <doughnut-chart
                      :chart-data="finPlanDistChartData"
                      :options="finPlanDistChartOptions"
                      :height="200"
                    />
                  </div>
                  <div class="mt-4">
                    <div
                      v-for="(seg, i) in finPlanDistribution"
                      :key="i"
                      class="d-flex align-center justify-space-between mb-2"
                    >
                      <div class="d-flex align-center">
                        <div class="rounded-circle mr-2" :style="{ width: '10px', height: '10px', backgroundColor: seg.color }" />
                        <span class="text-body-2">{{ seg.label }}</span>
                      </div>
                      <span class="text-body-2 font-weight-bold">{{ seg.count }} tenants</span>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- Faturas Recentes -->
            <v-card outlined rounded="lg" class="pa-5">
              <div class="d-flex align-center mb-4">
                <v-avatar color="grey lighten-3" size="40" class="mr-3">
                  <v-icon color="grey darken-2">mdi-file-document-outline</v-icon>
                </v-avatar>
                <span class="text-subtitle-1 font-weight-bold">Faturas Recentes</span>
              </div>
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">ID</th>
                      <th class="text-left">Tenant</th>
                      <th class="text-left">Valor</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(inv, i) in finRecentInvoices" :key="i">
                      <td class="font-weight-medium blue--text text--darken-2">{{ inv.id }}</td>
                      <td>{{ inv.tenant }}</td>
                      <td class="font-weight-medium">{{ formatCurrency(inv.amount) }}</td>
                      <td>
                        <v-chip
                          x-small
                          :color="inv.statusColor"
                          :text-color="inv.statusTextColor"
                          class="font-weight-medium"
                        >
                          {{ inv.statusLabel }}
                        </v-chip>
                      </td>
                      <td class="grey--text">{{ inv.date }}</td>
                    </tr>
                    <tr v-if="!finRecentInvoices.length">
                      <td colspan="5" class="text-center grey--text pa-4">Nenhuma fatura encontrada</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-tab-item>

          <!-- ==================== -->
          <!-- TAB: ALERTAS          -->
          <!-- ==================== -->
          <v-tab-item>
            <!-- RESUMO -->
            <div class="text-overline grey--text text--darken-1 mb-2 mt-1">RESUMO</div>
            <v-row class="mb-4">
              <!-- Alertas Abertos -->
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="red lighten-4" size="44" class="mr-3">
                      <v-icon color="red darken-1">mdi-bell-alert-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Alertas Abertos</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ alertsKpiOpen }}</div>
                      <div class="text-caption grey--text">{{ alertsKpiOpenDetail }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- Resolvidos Hoje -->
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="green lighten-4" size="44" class="mr-3">
                      <v-icon color="green darken-2">mdi-check-circle-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Resolvidos Hoje</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ alertsKpiResolvedToday }}</div>
                      <div class="text-caption grey--text">{{ alertsKpiResolvedTodayDetail }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- Tempo Médio Resolução -->
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="blue-grey lighten-4" size="44" class="mr-3">
                      <v-icon color="blue-grey darken-1">mdi-clock-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Tempo Médio Resolução</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ alertsKpiAvgResolution }}</div>
                      <div class="text-caption grey--text">{{ alertsKpiAvgResolutionDetail }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- Regras Ativas -->
              <v-col cols="12" sm="6" md="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="deep-orange lighten-4" size="44" class="mr-3">
                      <v-icon color="deep-orange darken-1">mdi-cog-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Regras Ativas</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ alertsKpiActiveRules }}</div>
                      <div class="text-caption grey--text">{{ alertsKpiActiveRulesDetail }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- ALERTAS ATIVOS -->
            <div class="d-flex align-center justify-space-between mb-2">
              <div class="text-overline grey--text text--darken-1">ALERTAS ATIVOS</div>
              <div class="d-flex" style="gap: 8px;">
                <v-btn
                  v-if="alertsListData.length > 0"
                  x-small
                  text
                  color="red"
                  @click="clearAllAlerts()"
                  :loading="clearingAlerts"
                >
                  <v-icon x-small left>mdi-delete-sweep</v-icon>
                  Limpar todos
                </v-btn>
              </div>
            </div>

            <!-- Filtros -->
            <div class="d-flex align-center mb-4" style="gap: 8px;">
              <v-chip
                :outlined="alertsTabFilter !== 'open'"
                :color="alertsTabFilter === 'open' ? 'grey darken-3' : 'grey lighten-2'"
                :text-color="alertsTabFilter === 'open' ? 'white' : 'grey darken-2'"
                small
                @click="alertsTabFilter = 'open'"
              >
                Abertos ({{ alertsFilteredCount('open') }})
              </v-chip>
              <v-chip
                :outlined="alertsTabFilter !== 'moderate'"
                :color="alertsTabFilter === 'moderate' ? 'grey darken-3' : 'grey lighten-2'"
                :text-color="alertsTabFilter === 'moderate' ? 'white' : 'grey darken-2'"
                small
                @click="alertsTabFilter = 'moderate'"
              >
                Moderados ({{ alertsFilteredCount('moderate') }})
              </v-chip>
              <v-chip
                :outlined="alertsTabFilter !== 'resolved'"
                :color="alertsTabFilter === 'resolved' ? 'grey darken-3' : 'grey lighten-2'"
                :text-color="alertsTabFilter === 'resolved' ? 'white' : 'grey darken-2'"
                small
                @click="alertsTabFilter = 'resolved'"
              >
                Resolvidos ({{ alertsFilteredCount('resolved') }})
              </v-chip>
              <v-chip
                :outlined="alertsTabFilter !== 'all'"
                :color="alertsTabFilter === 'all' ? 'grey darken-3' : 'grey lighten-2'"
                :text-color="alertsTabFilter === 'all' ? 'white' : 'grey darken-2'"
                small
                @click="alertsTabFilter = 'all'"
              >
                Todos
              </v-chip>
            </div>

            <!-- Lista de Alertas Cards -->
            <div
              v-for="(alert, i) in alertsActiveFiltered"
              :key="'alert-' + i"
              class="mb-3 pa-5 rounded-lg"
              :style="{
                border: '1px solid ' + getAlertBorderColor(alert.severity),
                borderLeft: '4px solid ' + getAlertBorderColor(alert.severity),
                backgroundColor: getAlertCardBg(alert.severity),
              }"
            >
              <div class="d-flex align-start">
                <!-- Severity Icon -->
                <div class="mr-4 mt-1">
                  <v-icon :color="getAlertIconColorNew(alert.severity)" size="24">{{ getAlertIconNew(alert.severity) }}</v-icon>
                </div>

                <!-- Content -->
                <div class="flex-grow-1">
                  <!-- Title row -->
                  <div class="d-flex align-center justify-space-between mb-1">
                    <span class="text-body-1 font-weight-bold">{{ alert.tenantName }} — {{ alert.title }}</span>
                    <div class="d-flex align-center" style="gap: 8px;">
                      <v-chip
                        x-small
                        :color="getAlertSeverityChipColor(alert.severity)"
                        :text-color="getAlertSeverityChipTextColor(alert.severity)"
                        class="font-weight-bold"
                      >
                        {{ getAlertSeverityLabelNew(alert.severity) }}
                      </v-chip>
                      <span class="text-caption grey--text">{{ alertTimeAgo(alert.createdAt) }}</span>
                    </div>
                  </div>

                  <!-- Description -->
                  <div class="text-body-2 grey--text text--darken-2 mb-2">{{ alert.description }}</div>

                  <!-- Suggested Action + Buttons row -->
                  <div class="d-flex align-end justify-space-between">
                    <div v-if="alert.suggestedAction">
                      <span class="text-caption font-weight-bold" :style="{ color: getAlertActionColor(alert.severity) }">Ação sugerida: </span>
                      <span class="text-caption grey--text text--darken-1">{{ alert.suggestedAction }}</span>
                    </div>
                    <div v-else></div>

                    <!-- Action buttons (only for non-resolved) -->
                    <div v-if="alert.status !== 'resolved'" class="d-flex align-center" style="gap: 8px;">
                      <v-btn
                        v-for="(action, ai) in getAlertActions(alert)"
                        :key="ai"
                        small
                        outlined
                        :color="action.color || 'grey darken-1'"
                        @click="handleAlertAction(alert, action.key)"
                      >
                        {{ action.label }}
                      </v-btn>
                      <v-btn icon x-small color="red lighten-1" @click="deleteAlertSingle(alert)" title="Excluir alerta">
                        <v-icon small>mdi-delete-outline</v-icon>
                      </v-btn>
                    </div>
                    <!-- Delete for resolved alerts -->
                    <div v-else class="d-flex align-center" style="gap: 8px;">
                      <v-btn icon x-small color="red lighten-1" @click="deleteAlertSingle(alert)" title="Excluir alerta">
                        <v-icon small>mdi-delete-outline</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty state -->
            <div v-if="alertsActiveFiltered.length === 0" class="text-center py-10">
              <v-icon size="56" color="green lighten-2">mdi-check-circle-outline</v-icon>
              <p class="text-body-1 grey--text mt-3">Nenhum alerta encontrado para este filtro.</p>
            </div>
          </v-tab-item>

          <!-- ==================== -->
          <!-- TAB: DEMOS            -->
          <!-- ==================== -->
          <v-tab-item>
            <!-- KPI Cards -->
            <v-row class="mb-4">
              <v-col cols="12" sm="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="blue lighten-4" size="48" class="mr-4">
                      <v-icon color="blue darken-1">mdi-calendar-check</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Agendadas</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ demoKpis.scheduled7d }}</div>
                      <div class="text-caption grey--text">próximos 7 dias</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="teal lighten-4" size="48" class="mr-4">
                      <v-icon color="teal darken-2">mdi-video-check</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Realizadas</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ demoKpis.realized }}</div>
                      <div class="text-caption grey--text">este mês</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="green lighten-4" size="48" class="mr-4">
                      <v-icon color="green darken-2">mdi-chart-line</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Taxa Conversão</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ demoKpis.conversionRate }}%</div>
                      <div class="text-caption grey--text">demo → trial</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" sm="3">
                <v-card outlined rounded="lg" class="pa-4 kpi-card">
                  <div class="d-flex align-center">
                    <v-avatar color="orange lighten-4" size="48" class="mr-4">
                      <v-icon color="orange darken-2">mdi-timer-outline</v-icon>
                    </v-avatar>
                    <div>
                      <div class="text-caption grey--text text--darken-1 font-weight-medium text-uppercase">Lead Time Médio</div>
                      <div class="text-h4 font-weight-bold mt-1">{{ demoKpis.avgLeadTimeDays }}d</div>
                      <div class="text-caption grey--text">lead → demo</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
            </v-row>

            <!-- Charts Row -->
            <v-row class="mb-4">
              <!-- Lead Time por etapa -->
              <v-col cols="12" md="5">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center mb-5">
                    <v-icon color="orange darken-2" class="mr-2">mdi-timer-sand</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Lead Time por etapa</span>
                  </div>
                  <div v-if="loadingDemoAnalytics" class="text-center py-8">
                    <v-progress-circular indeterminate color="teal" />
                  </div>
                  <div v-else>
                    <div
                      v-for="(stage, i) in demoLeadTimeStages"
                      :key="i"
                      class="mb-5"
                    >
                      <div class="d-flex align-center justify-space-between mb-1">
                        <span class="text-body-2 grey--text text--darken-2">{{ stage.label }}</span>
                        <span class="text-body-2 font-weight-bold">{{ stage.days }}d</span>
                      </div>
                      <div class="demo-lt-track">
                        <div
                          class="demo-lt-bar"
                          :style="{ width: Math.min((stage.days / demoLeadTimeMax) * 100, 100) + '%', background: stage.color }"
                        />
                      </div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <!-- Evolução Lead Time -->
              <v-col cols="12" md="7">
                <v-card outlined rounded="lg" class="pa-5" style="height: 100%">
                  <div class="d-flex align-center mb-4">
                    <v-icon color="teal darken-1" class="mr-2">mdi-chart-bar</v-icon>
                    <span class="text-subtitle-1 font-weight-bold">Evolução Lead Time (dias)</span>
                  </div>
                  <div v-if="loadingDemoAnalytics" class="text-center py-8">
                    <v-progress-circular indeterminate color="teal" />
                  </div>
                  <bar-chart
                    v-else
                    :chart-data="demoLeadTimeEvolutionChartData"
                    :options="demoLeadTimeEvolutionChartOptions"
                    :height="200"
                  />
                </v-card>
              </v-col>
            </v-row>

            <!-- Pipeline de conversão -->
            <v-card outlined rounded="lg" class="pa-5 mb-4">
              <div class="d-flex align-center mb-5">
                <v-icon color="blue darken-1" class="mr-2">mdi-arrow-right-bold-circle</v-icon>
                <span class="text-subtitle-1 font-weight-bold">Pipeline de conversão</span>
              </div>
              <div v-if="loadingDemoAnalytics" class="text-center py-4">
                <v-progress-circular indeterminate color="blue" />
              </div>
              <div v-else class="d-flex align-center flex-wrap" style="gap: 0">
                <div
                  v-for="(stage, i) in demoPipelineStages"
                  :key="i"
                  class="d-flex align-center"
                >
                  <div class="text-center" style="min-width: 72px;">
                    <v-avatar :color="stage.color" size="52" class="mb-1">
                      <span class="white--text text-h6 font-weight-bold">{{ stage.count }}</span>
                    </v-avatar>
                    <div class="text-caption grey--text text--darken-2" style="line-height: 1.3; font-size: 11px !important; white-space: pre-line;">{{ stage.label }}</div>
                  </div>
                  <v-icon v-if="i < demoPipelineStages.length - 1" color="grey lighten-1" class="mx-1" small>mdi-arrow-right</v-icon>
                </div>
              </div>
            </v-card>

            <!-- Agenda de Demos -->
            <v-card outlined rounded="lg" class="pa-5">
              <div class="d-flex align-center justify-space-between mb-4">
                <div class="d-flex align-center">
                  <v-icon color="blue darken-1" class="mr-2">mdi-calendar-month</v-icon>
                  <span class="text-subtitle-1 font-weight-bold">Agenda de Demos</span>
                </div>
                <v-btn icon small @click="loadDemoRequests" :loading="loadingDemos">
                  <v-icon small>mdi-refresh</v-icon>
                </v-btn>
              </div>
              <v-data-table
                :headers="demoHeaders"
                :items="demoRequests"
                :loading="loadingDemos"
                class="demos-table"
                no-data-text="Nenhuma demo encontrada"
                :items-per-page="10"
                :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
              >
                <template v-slot:item.leadName="{ item }">
                  <div class="d-flex align-center">
                    <v-icon small color="grey darken-1" class="mr-1">mdi-account-circle</v-icon>
                    <span class="font-weight-medium">{{ item.leadName || item.name }}</span>
                  </div>
                </template>
                <template v-slot:item.leadCreatedAt="{ item }">
                  {{ formatDemoDateShort(item.leadCreatedAt || item.createdAt) }}
                </template>
                <template v-slot:item.demoDate="{ item }">
                  {{ formatDemoDateShort(item.demoDate || item.scheduledAt) }}
                </template>
                <template v-slot:item.leadTimeDays="{ item }">
                  <span :class="(item.leadTimeDays || 0) > 14 ? 'orange--text text--darken-2 font-weight-bold' : 'grey--text text--darken-2'">
                    {{ item.leadTimeDays != null ? item.leadTimeDays + 'd' : '—' }}
                  </span>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    :color="getDemoAgendaStatusColor(item.status)"
                    :text-color="getDemoAgendaStatusTextColor(item.status)"
                    class="font-weight-medium"
                  >
                    {{ getDemoAgendaStatusLabel(item.status) }}
                  </v-chip>
                </template>
                <template v-slot:item.resultado="{ item }">
                  <v-chip
                    v-if="item.resultado && item.resultado !== 'NONE'"
                    small
                    :color="getDemoResultadoColor(item.resultado)"
                    :text-color="getDemoResultadoTextColor(item.resultado)"
                    class="font-weight-medium"
                  >
                    {{ getDemoResultadoLabel(item.resultado) }}
                  </v-chip>
                  <span v-else class="grey--text">—</span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-menu offset-y left>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on">
                        <v-icon small color="grey darken-2">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense>
                      <v-list-item v-if="!['CONTACTED','CONVERTED'].includes(item.status)" @click="updateDemoStatus(item, 'CONTACTED')">
                        <v-list-item-icon><v-icon small color="teal">mdi-video-check</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title>Marcar Realizada</v-list-item-title></v-list-item-content>
                      </v-list-item>
                      <v-list-item v-if="item.status !== 'DISMISSED'" @click="updateDemoStatus(item, 'DISMISSED')">
                        <v-list-item-icon><v-icon small color="red">mdi-close-circle</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title>Cancelar</v-list-item-title></v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="updateDemoResultado(item, 'CONVERTIDO')">
                        <v-list-item-icon><v-icon small color="green">mdi-check-circle</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title>Marcar Convertido</v-list-item-title></v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="updateDemoResultado(item, 'PERDIDO')">
                        <v-list-item-icon><v-icon small color="grey">mdi-close</v-icon></v-list-item-icon>
                        <v-list-item-content><v-list-item-title>Marcar Perdido</v-list-item-title></v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </v-main>

    <!-- Dialog de confirmação — Limpar todos os alertas -->
    <v-dialog v-model="confirmClearAlertsDialog" max-width="420" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="pt-6 pb-2">
          <v-icon color="red darken-1" left>mdi-alert-circle-outline</v-icon>
          Excluir todos os alertas
        </v-card-title>
        <v-card-text class="pb-2 grey--text text--darken-2">
          Essa ação é <strong>irreversível</strong>. Todos os alertas listados serão excluídos permanentemente.
          <br /><br />Deseja continuar?
        </v-card-text>
        <v-card-actions class="px-6 pb-5 pt-2">
          <v-spacer />
          <v-btn
            text
            @click="confirmClearAlertsDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            depressed
            color="red darken-1"
            dark
            :loading="clearingAlerts"
            @click="confirmClearAlertsExecute()"
          >
            <v-icon small left>mdi-delete-sweep</v-icon>
            Excluir todos
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-app>
</template>

<script>
import { PlatformService, TenantsService } from '@/services'
import TenantAvatarService from '@/services/tenant-avatar.service'
import api from '@/services/api'
import BarChart from './components/BarChart.vue'
import DoughnutChart from './components/DoughnutChart.vue'
import LineChart from './components/LineChart.vue'
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'

export default {
  name: 'DashboardOwner',

  components: {
    BarChart,
    DoughnutChart,
    LineChart,
  },

  data: () => ({
    // Tab ativa
    activeTab: 0,

    // Badge de alertas
    alertCount: 5,

    // Estatísticas
    stats: {
      activeTenants: 0,
      totalUsers: 0,
      mrr: 0,
      trialTenants: 0,
    },

    // Dados dos gráficos
    tenantsMonthlyData: [],
    usersByTenantData: [],
    mrrMonthlyData: [],

    // Tenants
    tenants: [],
    tenantFilter: 'all',
    tenantSearch: '',
    syncingMetadata: false,

    // Novo Tenant Dialog
    showNewTenantDialog: false,
    creatingTenant: false,
    newTenant: {
      name: '',
      plan: 'STARTER',
      maxUsers: 10,
      adminName: '',
      adminEmail: '',
      // companyData
      razaoSocial: '',
      nomeFantasia: '',
      cnpj: '',
      setor: '',
      telefone: '',
      email: '',
      endereco: '',
      website: '',
      porteEmpresa: '',
    },
    // Wizard: passo atual (1 = dados, 2 = upload avatar)
    newTenantStep: 1,
    // Erro ao criar tenant (exibido no dialog)
    createTenantError: '',
    // Tenant recém-criado (resposta do backend)
    createdTenant: null,
    // Upload avatar do tenant (wizard passo 2)
    selectedTenantFile: null,
    previewTenantAvatar: null,
    uploadingTenantAvatar: false,
    
    // Avatar do tenant - novo fluxo (em memória durante step 1)
    newTenantAvatarBlob: null,
    newTenantShowCropPreview: false,
    newTenantCropDialogStep1: false,
    
    // Crop de avatar (new tenant wizard)
    newTenantCropDialog: false,
    newTenantImageToCrop: null,
    newTenantCropper: null,
    
    // Favicon do novo tenant
    newTenantFaviconFile: null,
    newTenantPreviewFavicon: null,
    uploadingNewTenantFavicon: false,
    
    // Edit Tenant Dialog
    showEditTenantDialog: false,
    editingTenant: null,
    editTenantData: {
      name: '',
      plan: 'STARTER',
      maxUsers: 10,
    },
    savingTenant: false,
    
    // Crop de avatar (edit)
    editCropDialog: false,
    editImageToCrop: null,
    editCropper: null,
    editSelectedFile: null,
    editPreviewAvatar: null,
    uploadingEditAvatar: false,
    // Favicon (edit)
    editPreviewFavicon: null,
    uploadingEditFavicon: false,
    planOptions: [
      { text: 'Starter', value: 'STARTER' },
      { text: 'Standard', value: 'STANDARD' },
      { text: 'Enterprise', value: 'ENTERPRISE' },
    ],

    planDetails: [
      {
        value: 'STARTER',
        name: 'Starter',
        icon: 'mdi-rocket-launch',
        users: 'Até 10 usuários',
        description: 'Times pequenos, POCs ou uso inicial da plataforma',
      },
      {
        value: 'STANDARD',
        name: 'Standard',
        icon: 'mdi-office-building',
        users: 'De 11 até 100 usuários',
        description: 'Empresas em crescimento e múltiplos times',
      },
      {
        value: 'ENTERPRISE',
        name: 'Enterprise',
        icon: 'mdi-domain',
        users: 'Acima de 100 usuários',
        description: 'Limite ilimitado ou negociável. Pacotes por volume disponíveis',
      },
    ],

    // Headers da tabela de tenants
    tenantHeaders: [
      { text: 'Tenant', value: 'name', sortable: true },
      { text: 'Usuários', value: 'userCount', sortable: true },
      { text: 'Convite Admin', value: 'inviteStatus', sortable: true },
      { text: 'Próximo Venc.', value: 'subscriptionExpiresAt', sortable: true },
      { text: 'Plano', value: 'plan', sortable: true },
      { text: 'Status', value: 'status', sortable: true },
      { text: 'Valor', value: 'monthlyValue', sortable: true },
      { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
    ],

    // Loading states
    loadingStats: false,
    loadingCharts: false,
    loadingTable: false,

    // Dados reais carregados dos endpoints
    alertsData: [],         // /api/platform/dashboard/alerts
    financeByTenantData: [], // /api/platform/dashboard/finance/by-tenant
    mrrMonthlyRealData: [],  // /api/platform/dashboard/finance/mrr-monthly
    tenantMetadata: [],      // /api/admin/tenant-metadata
    usersMonthlyData: [],    // /api/platform/dashboard/users/monthly
    conversionData: null,    // /api/platform/dashboard/conversion
    recentActivityData: [],  // /api/platform/dashboard/activity/recent
    healthScoresData: [],    // /api/platform/dashboard/health-scores
    tenantActivityData: [],  // /api/platform/dashboard/tenant-activity

    // Engajamento - dados reais dos endpoints
    engagementSummary: null,     // /api/platform/dashboard/engagement/summary
    engagementFeatures: [],      // /api/platform/dashboard/engagement/features
    engagementNps: null,         // /api/platform/dashboard/engagement/nps
    engagementPeakHours: [],     // /api/platform/dashboard/engagement/peak-hours
    engagementTopUsers: [],      // /api/platform/dashboard/engagement/top-users

    // Financeiro - dados reais dos endpoints
    finHealthData: null,       // /api/platform/dashboard/finance/health
    finChurnMonthly: [],       // /api/platform/dashboard/finance/churn-monthly
    finInvoices: [],           // /api/platform/dashboard/finance/invoices

    // Alertas — dados do endpoint /alerts/summary + /alerts
    alertsTabFilter: 'all',
    alertsSummaryData: null,     // { openCount, criticalCount, moderateCount, resolvedTodayCount, resolvedTodayTitle, avgResolutionHours, activeRules, totalRules }
    alertsListData: [],          // real data from /alerts/list
    generatingAlerts: false,
    clearingAlerts: false,
    confirmClearAlertsDialog: false,

    // Demo Requests
    demoRequests: [],
    loadingDemos: false,
    updatingDemo: false,
    demoStatusFilter: '',
    demoAnalytics: null,
    loadingDemoAnalytics: false,
    demoHeaders: [
      { text: 'Lead', value: 'leadName', sortable: true },
      { text: 'Empresa', value: 'company', sortable: true },
      { text: 'Email', value: 'email', sortable: true },
      { text: 'Lead Criado', value: 'leadCreatedAt', sortable: true },
      { text: 'Data Demo', value: 'demoDate', sortable: true },
      { text: 'Lead Time', value: 'leadTimeDays', sortable: true, align: 'center' },
      { text: 'Status', value: 'status', sortable: true, align: 'center' },
      { text: 'Resultado', value: 'resultado', sortable: false, align: 'center' },
      { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
    ],
    showDismissDialog: false,
    dismissNotes: '',
    dismissTarget: null,

    // Cores para o gráfico doughnut
    chartColors: [
      '#2196F3', // Blue
      '#4CAF50', // Green
      '#FFC107', // Amber
      '#9C27B0', // Purple
      '#F44336', // Red
      '#FF9800', // Orange
      '#00BCD4', // Cyan
      '#E91E63', // Pink
      '#3F51B5', // Indigo
      '#009688', // Teal
    ],


  }),

  computed: {
    demoPendingCount() {
      return this.demoRequests.filter(d => d.status === 'PENDING').length
    },
    demoConvertedCount() {
      return this.demoRequests.filter(d => d.status === 'CONVERTED').length
    },
    demoScheduledCount() {
      return this.demoRequests.filter(d => ['SCHEDULED', 'PENDING'].includes(d.status)).length
    },

    demoKpis() {
      const a = this.demoAnalytics
      if (a) {
        return {
          scheduled7d: a.scheduled7d ?? this.demoScheduledCount,
          realized: a.realized ?? 0,
          conversionRate: a.conversionRate ?? 0,
          avgLeadTimeDays: a.avgLeadTimeDays ?? 0,
        }
      }
      // Deriva dos demo-requests quando endpoint de analytics nao retornou
      const now = new Date()
      const in7d = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000)
      const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1)
      const scheduled7d = this.demoRequests.filter(d => {
        if (!['PENDING', 'SCHEDULED'].includes(d.status)) return false
        const dd = d.demoDate ? new Date(d.demoDate) : null
        return dd && dd >= now && dd <= in7d
      }).length
      const realized = this.demoRequests.filter(d => {
        if (!['CONTACTED', 'CONVERTED'].includes(d.status)) return false
        const dd = d.demoDate ? new Date(d.demoDate) : null
        return dd && dd >= thisMonthStart
      }).length
      const total = this.demoRequests.length
      const converted = this.demoRequests.filter(d => d.status === 'CONVERTED').length
      const conversionRate = total > 0 ? Math.round((converted / total) * 100) : 0
      const withLeadTime = this.demoRequests.filter(d => d.leadTimeDays != null)
      const avgLeadTimeDays = withLeadTime.length > 0
        ? Math.round(withLeadTime.reduce((s, d) => s + d.leadTimeDays, 0) / withLeadTime.length)
        : 0
      return { scheduled7d, realized, conversionRate, avgLeadTimeDays }
    },

    demoLeadTimeStages() {
      if (this.demoAnalytics?.leadTimeStages) return this.demoAnalytics.leadTimeStages
      // Deriva media de leadTimeDays para os status disponiveis
      const all = this.demoRequests.filter(d => d.leadTimeDays != null)
      const avg = all.length > 0 ? Math.round(all.reduce((s, d) => s + d.leadTimeDays, 0) / all.length) : 0
      return [
        { label: 'Lead → Demo', days: avg || 0, color: '#26A69A' },
        { label: 'Demo → Trial', days: this.demoAnalytics?.demoToTrial ?? 0, color: '#26A69A' },
        { label: 'Trial → Conversão', days: this.demoAnalytics?.trialToConv ?? 0, color: '#26A69A' },
        { label: 'Lead → Conversão', days: this.demoAnalytics?.leadToConv ?? (avg ? avg * 2 : 0), color: '#EF6C00' },
      ]
    },

    demoLeadTimeMax() {
      if (!this.demoLeadTimeStages.length) return 1
      return Math.max(...this.demoLeadTimeStages.map(s => s.days))
    },

    demoPipelineStages() {
      if (this.demoAnalytics?.pipeline) return this.demoAnalytics.pipeline
      return [
        { label: 'Leads', count: this.demoRequests.length || 0, color: 'grey darken-1' },
        { label: 'Demo\nAgendada', count: this.demoScheduledCount, color: 'blue darken-1' },
        { label: 'Demo\nRealizada', count: this.demoRequests.filter(d => ['CONTACTED', 'CONVERTED'].includes(d.status)).length, color: 'teal darken-1' },
        { label: 'Trial Ativo', count: this.demoAnalytics?.trialActive ?? 0, color: 'amber darken-1' },
        { label: 'Convertido', count: this.demoConvertedCount, color: 'orange darken-2' },
      ]
    },

    demoLeadTimeEvolutionChartData() {
      const evo = this.demoAnalytics?.leadTimeEvolution
      const months = evo ? evo.map(e => e.month) : ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun']
      const datasets = evo
        ? [
            { label: 'Lead→Demo', data: evo.map(e => e.leadToDemo ?? 0), backgroundColor: '#26A69A', borderRadius: 3 },
            { label: 'Demo→Trial', data: evo.map(e => e.demoToTrial ?? 0), backgroundColor: '#FDD835', borderRadius: 3 },
            { label: 'Trial→Conv.', data: evo.map(e => e.trialToConv ?? 0), backgroundColor: '#42A5F5', borderRadius: 3 },
          ]
        : [
            { label: 'Lead→Demo', data: [13, 12, 12, 11, 6, 12], backgroundColor: '#26A69A', borderRadius: 3 },
            { label: 'Demo→Trial', data: [5, 20, 13, 2, 18, 2], backgroundColor: '#FDD835', borderRadius: 3 },
            { label: 'Trial→Conv.', data: [6, 5, 4, 3, 2, 12], backgroundColor: '#42A5F5', borderRadius: 3 },
          ]
      return { labels: months, datasets }
    },

    demoLeadTimeEvolutionChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          xAxes: [{ gridLines: { display: false }, ticks: { fontSize: 11 } }],
          yAxes: [{ gridLines: { color: '#f0f0f0' }, ticks: { fontSize: 11, stepSize: 6, beginAtZero: true } }],
        },
        tooltips: { mode: 'index', intersect: false },
      }
    },

    // ====== VISÃO GERAL: computed a partir de dados reais ======

    // +N tenants este mês — último item do tenantsMonthlyData
    tenantsThisMonth() {
      if (!this.tenantsMonthlyData.length) return 0
      return this.tenantsMonthlyData[this.tenantsMonthlyData.length - 1].count || 0
    },

    // +N usuários este mês — último item do usersMonthlyData (endpoint real)
    usersThisMonth() {
      if (!this.usersMonthlyData.length) return 0
      return this.usersMonthlyData[this.usersMonthlyData.length - 1].count || 0
    },

    // Taxa de conversão — do endpoint /conversion
    conversionRate() {
      if (!this.conversionData || this.conversionData.conversionRate == null) return '—'
      return `${this.conversionData.conversionRate.toFixed(1)}%`
    },

    // Nota de conversão
    conversionNote() {
      if (!this.conversionData) return 'carregando...'
      const avg = this.conversionData.avgTrialDays
      if (avg > 0) return `média ${avg}d de trial`
      return `${this.conversionData.converted || 0} convertidos`
    },

    // Nota de trials expirando
    expiringTrialNote() {
      if (!this.conversionData) return ''
      const exp = this.conversionData.expiringIn7d || 0
      if (exp > 0) return `${exp} expirando em 7d`
      return `${this.conversionData.trialExpired || 0} expirados`
    },

    // MRR total — soma de finance/by-tenant
    totalMrr() {
      if (!this.financeByTenantData.length) return this.stats.mrr || 0
      return this.financeByTenantData.reduce((sum, t) => sum + (t.value || 0), 0)
    },

    // Tenants pagantes — quantos têm value > 0
    payingTenantsCount() {
      return this.financeByTenantData.filter(t => t.value > 0).length
    },

    // Alertas abertos — total do endpoint alerts
    alertsOpenCount() {
      return this.alertsData.length
    },

    // Alertas críticos
    alertsCriticalCount() {
      return this.alertsData.filter(a => a.severity === 'critical').length
    },

    // === ALERTAS TAB — KPI computed ===
    alertsKpiOpen() {
      if (this.alertsSummaryData) return this.alertsSummaryData.openCount
      return this.alertsListData.filter(a => a.status !== 'resolved').length
    },
    alertsKpiOpenDetail() {
      if (this.alertsSummaryData) {
        const parts = []
        if (this.alertsSummaryData.criticalCount) parts.push(`${this.alertsSummaryData.criticalCount} críticos`)
        if (this.alertsSummaryData.moderateCount) parts.push(`${this.alertsSummaryData.moderateCount} moderado`)
        return parts.join(', ') || ''
      }
      const crit = this.alertsListData.filter(a => a.severity === 'critical' && a.status !== 'resolved').length
      const mod = this.alertsListData.filter(a => a.severity === 'moderate' && a.status !== 'resolved').length
      const parts = []
      if (crit) parts.push(`${crit} críticos`)
      if (mod) parts.push(`${mod} moderado`)
      return parts.join(', ')
    },
    alertsKpiResolvedToday() {
      if (this.alertsSummaryData) return this.alertsSummaryData.resolvedTodayCount
      const today = new Date().toDateString()
      return this.alertsListData.filter(a => a.status === 'resolved' && a.resolvedAt && new Date(a.resolvedAt).toDateString() === today).length
    },
    alertsKpiResolvedTodayDetail() {
      if (this.alertsSummaryData && this.alertsSummaryData.resolvedTodayTitle) return this.alertsSummaryData.resolvedTodayTitle
      const today = new Date().toDateString()
      const resolved = this.alertsListData.filter(a => a.status === 'resolved' && a.resolvedAt && new Date(a.resolvedAt).toDateString() === today)
      return resolved.length ? resolved[0].title : ''
    },
    alertsKpiAvgResolution() {
      if (this.alertsSummaryData && this.alertsSummaryData.avgResolutionHours != null) {
        const h = this.alertsSummaryData.avgResolutionHours
        if (h < 24) return `${Math.round(h)}h`
        return `${Math.round(h / 24)}d`
      }
      return '—'
    },
    alertsKpiAvgResolutionDetail() {
      if (this.alertsSummaryData && this.alertsSummaryData.avgResolutionHours != null) return ''
      return 'dados insuficientes'
    },
    alertsKpiActiveRules() {
      if (this.alertsSummaryData) return this.alertsSummaryData.activeRules || 0
      return 6
    },
    alertsKpiActiveRulesDetail() {
      if (this.alertsSummaryData) return `de ${this.alertsSummaryData.totalRules || 0} configuradas`
      return 'de 8 configuradas'
    },

    // Filtro de alertas ativos
    alertsActiveFiltered() {
      const list = this.alertsListData
      if (this.alertsTabFilter === 'open') return list.filter(a => a.severity === 'critical' && a.status !== 'resolved' && a.status !== 'dismissed')
      if (this.alertsTabFilter === 'moderate') return list.filter(a => a.severity === 'moderate' && a.status !== 'resolved' && a.status !== 'dismissed')
      if (this.alertsTabFilter === 'resolved') return list.filter(a => a.status === 'resolved')
      return list // 'all'
    },

    // Demos note  
    demosNote() {
      const count = this.demoScheduledCount
      if (count === 0) return 'nenhuma'
      return count === 1 ? 'próxima agendada' : `${count} agendadas`
    },

    // Risco de churn — tenants com lastSyncAt > 30 dias
    churnRiskCount() {
      const now = new Date()
      return this.tenantMetadata.filter(t => {
        if (!t.lastSyncAt) return true
        const diff = (now - new Date(t.lastSyncAt)) / (1000 * 60 * 60 * 24)
        return diff >= 30
      }).length
    },

    // Tenants em risco de churn — tabela derivada de tenant-metadata
    churnTenants() {
      const now = new Date()
      return this.tenantMetadata
        .map(t => {
          const lastSync = t.lastSyncAt ? new Date(t.lastSyncAt) : null
          const diffDays = lastSync ? Math.floor((now - lastSync) / (1000 * 60 * 60 * 24)) : 999
          let status = 'Saudável'
          if (diffDays >= 30) status = 'Crítico'
          else if (diffDays >= 15) status = 'Atenção'
          else if (t.userCount === 0 && diffDays >= 7) status = 'Inativo'
          let lastAccess = 'Nunca'
          if (lastSync) {
            if (diffDays === 0) lastAccess = 'Hoje'
            else if (diffDays === 1) lastAccess = '1 dia atrás'
            else lastAccess = `${diffDays} dias atrás`
          }
          return {
            name: t.companyName || 'Sem nome',
            lastAccess,
            users: t.userCount || 0,
            status,
            diffDays,
          }
        })
        .sort((a, b) => b.diffDays - a.diffDays)
        .slice(0, 8)
    },

    // Funil de conversão — dados do endpoint /conversion
    funnelData() {
      const c = this.conversionData
      if (c) {
        return [
          { label: 'Demos realizadas', value: c.demosRealized || 0, color: 'green' },
          { label: 'Trials iniciados', value: c.trialStarted || 0, color: 'blue' },
          { label: 'Tenants ativos', value: this.stats.activeTenants || 0, color: 'green darken-1' },
          { label: 'Convertidos (pagantes)', value: c.converted || 0, color: 'blue darken-2' },
          { label: 'Churn', value: c.churned || 0, color: 'red' },
        ]
      }
      // Fallback se endpoint não respondeu
      return [
        { label: 'Demos realizadas', value: this.demoConvertedCount + this.demoScheduledCount, color: 'green' },
        { label: 'Tenants ativos', value: this.stats.activeTenants || 0, color: 'green darken-1' },
        { label: 'Convertidos (pagantes)', value: this.payingTenantsCount, color: 'blue darken-2' },
        { label: 'Churn (risco)', value: this.churnRiskCount, color: 'red' },
      ]
    },

    funnelMax() {
      if (!this.funnelData.length) return 1
      return Math.max(...this.funnelData.map(f => f.value), 1)
    },

    // Score de saúde por tenant — do endpoint /health-scores
    healthScores() {
      if (this.healthScoresData.length) {
        return this.healthScoresData
          .map(t => ({ name: t.tenantName, score: t.score }))
          .sort((a, b) => b.score - a.score)
          .slice(0, 6)
      }
      // Fallback calculado localmente
      const mrrMap = {}
      this.financeByTenantData.forEach(f => {
        mrrMap[f.tenant] = (mrrMap[f.tenant] || 0) + (f.value || 0)
      })
      const userMap = {}
      this.mergedUsersByTenant.forEach(u => {
        userMap[u.tenantName] = u.userCount || 0
      })
      const now = new Date()
      return this.tenantMetadata
        .map(t => {
          const name = t.companyName || 'Sem nome'
          const users = userMap[name] !== undefined ? userMap[name] : (t.userCount || 0)
          const mrr = mrrMap[name] || 0
          const lastSync = t.lastSyncAt ? new Date(t.lastSyncAt) : null
          const daysSinceSync = lastSync ? Math.floor((now - lastSync) / (1000 * 60 * 60 * 24)) : 999
          let activityScore = Math.max(0, 100 - (daysSinceSync * 3))
          let userScore = Math.min(100, users * 10)
          let mrrScore = Math.min(100, (mrr / 60))
          const score = Math.round(activityScore * 0.4 + userScore * 0.3 + mrrScore * 0.3)
          return { name, score: Math.max(0, Math.min(100, score)) }
        })
        .filter(t => t.name !== 'Unknown')
        .sort((a, b) => b.score - a.score)
        .slice(0, 6)
    },

    // Atividade recente — do endpoint /activity/recent, fallback para alertsData
    recentActivity() {
      const colorMap = {
        critical: '#F44336',
        warning: '#FF9800',
        info: '#2196F3',
      }
      const timeColorMap = {
        critical: 'red--text',
        warning: 'orange--text',
        info: 'blue--text',
      }

      // Se temos dados do endpoint real
      if (this.recentActivityData.length) {
        return this.recentActivityData
          .slice(0, 8)
          .map(a => {
            const daysAgo = Math.floor((new Date() - new Date(a.createdAt)) / (1000 * 60 * 60 * 24))
            let time = 'Hoje'
            if (daysAgo === 1) time = '1 dia atrás'
            else if (daysAgo > 1) time = `${daysAgo}d atrás`
            return {
              text: a.description || `${a.tenant}: ${a.type}`,
              time,
              color: colorMap[a.severity] || '#9E9E9E',
              timeColor: timeColorMap[a.severity] || 'grey--text',
            }
          })
      }

      // Fallback: usar alertsData
      return this.alertsData
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        .slice(0, 6)
        .map(a => {
          const daysAgo = Math.floor((new Date() - new Date(a.createdAt)) / (1000 * 60 * 60 * 24))
          let time = 'Hoje'
          if (daysAgo === 1) time = '1 dia atrás'
          else if (daysAgo > 1) time = `${daysAgo}d atrás`
          return {
            text: `${a.title}: ${a.description}`,
            time,
            color: colorMap[a.severity] || '#9E9E9E',
            timeColor: timeColorMap[a.severity] || 'grey--text',
          }
        })
    },

    // Classificação de Clientes — High/Mid/Low Touch com dados reais de finance/by-tenant
    clientTiers() {
      // Cruza finance com users
      const userMap = {}
      this.mergedUsersByTenant.forEach(u => {
        userMap[u.tenantName] = u.userCount || 0
      })

      // Agrupa por tenant (pode ter duplicatas no finance)
      const tenantMap = {}
      this.financeByTenantData.forEach(f => {
        if (!tenantMap[f.tenant]) {
          tenantMap[f.tenant] = { name: f.tenant, mrr: 0, users: userMap[f.tenant] || 0 }
        }
        tenantMap[f.tenant].mrr += f.value || 0
      })

      const all = Object.values(tenantMap)
      const totalMrr = all.reduce((s, t) => s + t.mrr, 0) || 1

      const high = all.filter(t => t.mrr >= 5000).sort((a, b) => b.mrr - a.mrr)
      const mid = all.filter(t => t.mrr >= 1000 && t.mrr < 5000).sort((a, b) => b.mrr - a.mrr)
      const low = all.filter(t => t.mrr < 1000).sort((a, b) => b.mrr - a.mrr)

      const pct = (arr) => Math.round(arr.reduce((s, t) => s + t.mrr, 0) / totalMrr * 100)

      return [
        {
          label: 'High Touch',
          range: 'Acima de R$ 5.000',
          borderColor: '#4CAF50',
          percentage: pct(high),
          clients: high.slice(0, 5),
        },
        {
          label: 'Mid Touch',
          range: 'R$ 1.000 a R$ 5.000',
          borderColor: '#FF9800',
          percentage: pct(mid),
          clients: mid.slice(0, 5),
        },
        {
          label: 'Low Touch',
          range: 'Abaixo de R$ 1.000',
          borderColor: '#F44336',
          percentage: pct(low),
          clients: low.slice(0, 5),
        },
      ]
    },

    // Trial tenants count (pelo metadata, planos STARTER sem MRR podem indicar trial)
    trialTenantsCount() {
      return this.tenantMetadata.filter(t => {
        const plan = (t.plan || '').toUpperCase()
        return plan === 'STARTER' || plan === 'TRIAL'
      }).length
    },

    // ====== ABA TENANTS: Cards de Tenants ======

    // Monta array enriquecido combinando tenants + metadata + healthScores
    tenantCards() {
      const now = new Date()

      // Mapas rápidos por tenantId e por nome
      const metaMap = {}
      this.tenantMetadata.forEach(m => {
        if (m.tenantId) metaMap[m.tenantId] = m
      })
      const metaByName = {}
      this.tenantMetadata.forEach(m => {
        if (m.companyName) metaByName[m.companyName.toLowerCase()] = m
      })

      const healthMap = {}
      this.healthScoresData.forEach(h => {
        if (h.tenantId) healthMap[h.tenantId] = h
      })
      const healthByName = {}
      this.healthScoresData.forEach(h => {
        if (h.tenantName) healthByName[h.tenantName.toLowerCase()] = h
      })

      // Mapa de usuários reais por tenant (do endpoint /users/by-tenant)
      const usersMap = {}
      this.usersByTenantData.forEach(u => {
        if (u.tenantId) usersMap[u.tenantId] = u.userCount || 0
      })
      const usersByName = {}
      this.usersByTenantData.forEach(u => {
        if (u.tenantName) usersByName[u.tenantName.toLowerCase()] = u.userCount || 0
      })

      // Mapa de atividade real (sessões + último login) do endpoint /tenant-activity
      const activityMap = {}
      this.tenantActivityData.forEach(a => {
        if (a.tenantId) activityMap[a.tenantId] = a
      })
      const activityByName = {}
      this.tenantActivityData.forEach(a => {
        if (a.tenantName) activityByName[a.tenantName.toLowerCase()] = a
      })

      return this.tenants.map(t => {
        const meta = metaMap[t.id] || metaByName[(t.name || '').toLowerCase()] || {}
        const health = healthMap[t.id] || healthByName[(t.name || '').toLowerCase()] || {}
        const nameLower = (t.name || '').toLowerCase()
        const activity = activityMap[t.id] || activityByName[nameLower] || {}

        // Contagem de usuários: tenantMetadata (fonte mais confiável, atualizada pelo scheduler)
        // > usersByTenant (fallback) > tenant.userCount (último fallback)
        const realUserCount = meta.userCount != null
          ? meta.userCount
          : usersMap[t.id] != null
            ? usersMap[t.id]
            : usersByName[nameLower] != null
              ? usersByName[nameLower]
              : t.userCount || 0

        // Último acesso: usa apenas lastLoginAt real (sem fallback para lastSyncAt)
        const lastLogin = activity.lastLoginAt ? new Date(activity.lastLoginAt) : null
        const daysSinceAccess = lastLogin ? Math.floor((now - lastLogin) / (1000 * 60 * 60 * 24)) : 999

        let lastAccessLabel = 'Nunca'
        if (lastLogin) {
          if (daysSinceAccess === 0) lastAccessLabel = 'Hoje'
          else if (daysSinceAccess === 1) lastAccessLabel = '1d'
          else lastAccessLabel = `${daysSinceAccess}d`
        }

        // Sessões reais dos últimos 30 dias
        const sessions = activity.sessions30d != null ? activity.sessions30d : null

        // Determinar status visual do card
        const status = (t.status || '').toUpperCase()
        let cardStatus = 'Ativo'
        if (status === 'SUSPENDED') cardStatus = 'Inativo'
        else if (status === 'TRIAL') cardStatus = 'Onboarding'
        else if (daysSinceAccess >= 30) cardStatus = 'Crítico'
        else if (daysSinceAccess >= 15 || (health.score != null && health.score < 40)) cardStatus = 'Em risco'
        else if (meta.provisionedAt) {
          const daysSinceCreated = Math.floor((now - new Date(meta.provisionedAt)) / (1000 * 60 * 60 * 24))
          if (daysSinceCreated <= 14 && status !== 'SUSPENDED') cardStatus = 'Onboarding'
        }

        return {
          ...t,
          userCount: realUserCount,
          provisionedAt: meta.provisionedAt || t.createdAt || null,
          lastLoginAt: activity.lastLoginAt || null,
          lastLoginUser: activity.lastLoginUser || null,
          lastAccessLabel,
          lastAccessDays: daysSinceAccess,
          healthScore: health.score != null ? health.score : 0,
          sessions,
          sessions7d: activity.sessions7d != null ? activity.sessions7d : null,
          cardStatus,
          filterGroup: cardStatus === 'Ativo' ? 'active'
            : cardStatus === 'Em risco' ? 'risk'
            : cardStatus === 'Crítico' ? 'inactive'
            : cardStatus === 'Inativo' ? 'inactive'
            : cardStatus === 'Onboarding' ? 'onboarding'
            : 'active',
        }
      })
    },

    // Contadores por status
    tenantCardsByStatus() {
      const counts = { active: 0, risk: 0, inactive: 0, onboarding: 0 }
      this.tenantCards.forEach(c => {
        if (c.filterGroup === 'active') counts.active++
        else if (c.filterGroup === 'risk') counts.risk++
        else if (c.filterGroup === 'inactive') counts.inactive++
        else if (c.filterGroup === 'onboarding') counts.onboarding++
      })
      return counts
    },

    // Ativos nos últimos 7 dias
    activeLast7dCount() {
      return this.tenantCards.filter(c => c.lastAccessDays <= 7).length
    },

    // Inativos 30+ dias
    inactive30dCount() {
      return this.tenantCards.filter(c => c.lastAccessDays >= 30).length
    },

    // Onboarding count
    onboardingTenantCount() {
      return this.tenantCardsByStatus.onboarding
    },

    // Cards filtrados
    filteredTenantCards() {
      let cards = this.tenantCards

      // Filtro por status
      if (this.tenantFilter !== 'all') {
        cards = cards.filter(c => c.filterGroup === this.tenantFilter)
      }

      // Filtro por busca
      if (this.tenantSearch) {
        const q = this.tenantSearch.toLowerCase().trim()
        cards = cards.filter(c =>
          (c.name || '').toLowerCase().includes(q) ||
          (c.adminEmail || '').toLowerCase().includes(q)
        )
      }

      return cards
    },

    tenantsChartData() {
      return {
        labels: this.tenantsMonthlyData.map(d => d.month),
        datasets: [{
          label: 'Novos Tenants',
          data: this.tenantsMonthlyData.map(d => d.count),
          backgroundColor: '#4CAF50',
          borderColor: '#388E3C',
          borderWidth: 1,
          borderRadius: 4,
          barPercentage: 0.5,
        }],
      }
    },

    tenantsChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              stepSize: 1,
              fontColor: '#999',
            },
            gridLines: {
              color: 'rgba(0,0,0,0.05)',
            },
          }],
          xAxes: [{
            ticks: { fontColor: '#999' },
            gridLines: { display: false },
          }],
        },
      }
    },

    usersChartData() {
      return {
        labels: this.mergedUsersByTenant.map(d => d.tenantName),
        datasets: [{
          data: this.mergedUsersByTenant.map(d => d.userCount),
          backgroundColor: this.chartColors,
          borderWidth: 3,
          borderColor: '#fff',
        }],
      }
    },

    usersChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        cutoutPercentage: 60,
      }
    },

    // Usuários por tenant com userCount correto: prioriza tenantMetadata (cobre DEDICATED + SHARED)
    // Fallback para usersByTenantData se metadata ainda não carregou
    mergedUsersByTenant() {
      if (this.tenantMetadata.length) {
        return this.tenantMetadata
          .filter(m => m.companyName && m.companyName !== 'Unknown')
          .map(m => ({
            tenantId: m.tenantId,
            tenantName: m.companyName,
            userCount: m.userCount || 0,
          }))
          .sort((a, b) => b.userCount - a.userCount)
      }
      // Fallback enquanto metadata não carregou
      return this.usersByTenantData
    },

    mrrChartData() {
      return {
        labels: this.mrrMonthlyData.map(d => d.month),
        datasets: [{
          label: 'MRR (R$)',
          data: this.mrrMonthlyData.map(d => d.value),
          borderColor: '#4CAF50',
          backgroundColor: 'rgba(76, 175, 80, 0.1)',
          borderWidth: 2,
          fill: true,
          tension: 0.4,
          pointBackgroundColor: '#4CAF50',
          pointBorderColor: '#fff',
          pointBorderWidth: 2,
          pointRadius: 0,
          pointHoverRadius: 5,
        }],
      }
    },

    mrrChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#999',
              callback: (value) => {
                if (value >= 1000) return `R$${(value / 1000).toFixed(0)}k`
                return `R$${value}`
              },
            },
            gridLines: {
              color: 'rgba(0,0,0,0.05)',
            },
          }],
          xAxes: [{
            ticks: { fontColor: '#999' },
            gridLines: { display: false },
          }],
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem) => {
              return `MRR: R$ ${Number(tooltipItem.yLabel).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
            },
          },
        },
      }
    },

    planLimits() {
      const limits = {
        STARTER: {
          min: 1,
          max: 10,
          hint: 'Plano Starter: de 1 até 10 usuários',
          error: 'O plano Starter permite de 1 a 10 usuários',
        },
        STANDARD: {
          min: 11,
          max: 100,
          hint: 'Plano Standard: de 11 até 100 usuários',
          error: 'O plano Standard permite de 11 a 100 usuários',
        },
        ENTERPRISE: {
          min: 101,
          max: null,
          hint: 'Plano Enterprise: acima de 100 usuários (ilimitado ou personalizado)',
          error: 'O plano Enterprise requer mais de 100 usuários',
        },
      }
      return limits[this.newTenant.plan] || { min: 1, max: null, hint: 'Selecione um plano', error: '' }
    },

    isNewTenantValid() {
      return (
        this.newTenant.name &&
        this.newTenant.plan &&
        this.newTenant.adminName &&
        this.newTenant.adminEmail &&
        /.+@.+\..+/.test(this.newTenant.adminEmail)
      )
    },

    editPlanLimits() {
      const limits = {
        STARTER: {
          min: 1,
          max: 10,
          hint: 'Plano Starter: de 1 até 10 usuários',
        },
        STANDARD: {
          min: 11,
          max: 100,
          hint: 'Plano Standard: de 11 até 100 usuários',
        },
        ENTERPRISE: {
          min: 101,
          max: null,
          hint: 'Plano Enterprise: acima de 100 usuários (ilimitado)',
        },
      }
      return limits[this.editTenantData.plan] || { min: 1, max: null, hint: '' }
    },

    // ====== ENGAJAMENTO: computed ======

    // KPI Summary — dados reais com fallback
    engSummary() {
      const s = this.engagementSummary
      if (s) {
        const diffMin = (s.avgSessionMinutes || 0) - (s.avgSessionMinutesPrev || 0)
        const diffSign = diffMin >= 0 ? '+' : ''
        return {
          sessionsPerDay: s.sessionsPerDay || 0,
          sessionsPerDayNote: `m\u00e9dia \u00faltimos 7 dias`,
          avgSessionMinutes: s.avgSessionMinutes || 0,
          avgSessionNote: `${diffSign}${diffMin}min vs m\u00eas anterior`,
          retentionD7: s.retentionD7 != null ? s.retentionD7 : 0,
          retentionD7Note: s.retentionD7 >= 60 ? 'acima da m\u00e9dia SaaS' : 'abaixo da m\u00e9dia SaaS',
          retentionD30: s.retentionD30 != null ? s.retentionD30 : 0,
          retentionD30Note: s.retentionD30 >= 40 ? 'dentro do esperado' : 'abaixo do esperado',
          stickiness: s.stickiness != null ? s.stickiness : 0,
          stickinessNote: `meta: 30%`,
        }
      }
      // Fallback: valores zerados enquanto carrega
      return {
        sessionsPerDay: 0, sessionsPerDayNote: 'carregando...',
        avgSessionMinutes: 0, avgSessionNote: '',
        retentionD7: 0, retentionD7Note: '',
        retentionD30: 0, retentionD30Note: '',
        stickiness: 0, stickinessNote: 'meta: 30%',
      }
    },

    // NPS — dados reais com fallback
    npsData() {
      const n = this.engagementNps
      if (n) {
        return {
          score: n.score || 0,
          totalResponses: n.totalResponses || 0,
          totalUsers: n.totalUsers || 0,
          responseRate: n.responseRate || 0,
          label: n.label || (n.score >= 50 ? 'Excelente' : n.score >= 0 ? 'Bom' : 'Ruim'),
          goal: 50,
          trend: n.trend || '',
          promoters: n.promoters || 0,
          neutrals: n.neutrals || 0,
          detractors: n.detractors || 0,
          evolution: n.evolution || [],
        }
      }
      return {
        score: 0, totalResponses: 0, totalUsers: 0, responseRate: 0,
        label: '\u2014', goal: 50, trend: '',
        promoters: 0, neutrals: 0, detractors: 0, evolution: [],
      }
    },

    // Features — dados reais mapeados para o formato do template
    engFeaturesList() {
      if (this.engagementFeatures.length) {
        return this.engagementFeatures.map(f => ({
          name: f.feature || f.name,
          percentage: f.percentage || 0,
        }))
      }
      return []
    },

    // Peak hours label — calculado a partir dos dados reais
    peakHoursLabel() {
      const data = this.engagementPeakHours
      if (!data.length) return '\u2014'
      const sorted = [...data].sort((a, b) => (b.sessions || b.value || 0) - (a.sessions || a.value || 0))
      const top2 = sorted.slice(0, 2)
      return top2.map(d => `${d.hour}h`).join(' e ')
    },

    // Tabela "Sessões por tenant" — dados reais de tenantActivityData + tenantCards
    engagementSessionsTable() {
      return this.tenantCards
        .filter(c => c.sessions != null)
        .sort((a, b) => (b.sessions || 0) - (a.sessions || 0))
        .slice(0, 8)
        .map(c => {
          const sessions = c.sessions || 0
          const totalUsers = c.userCount || 0
          // Estimar usuários ativos: se tem sessions7d, aprox 1 user p/ 5 sessions; senão proporcional
          const estimatedActive = c.sessions7d != null
            ? Math.min(totalUsers, Math.max(1, Math.round(c.sessions7d / 5)))
            : Math.min(totalUsers, Math.max(1, Math.round(sessions / 20)))

          let level = 'Inativo'
          let levelColor = 'grey lighten-3'
          let levelTextColor = 'grey darken-1'
          if (sessions >= 50) { level = 'Alto'; levelColor = 'green lighten-4'; levelTextColor = 'green darken-2' }
          else if (sessions >= 20) { level = 'Médio'; levelColor = 'orange lighten-4'; levelTextColor = 'orange darken-3' }
          else if (sessions > 0) { level = 'Baixo'; levelColor = 'red lighten-4'; levelTextColor = 'red darken-2' }

          return {
            name: c.name || c.companyName || 'Sem nome',
            sessions,
            activeUsers: estimatedActive,
            totalUsers,
            level,
            levelColor,
            levelTextColor,
          }
        })
    },

    // Segmentos de engajamento — derivado de tenantCards
    engagementSegments() {
      const cards = this.tenantCards
      const champions = cards.filter(c => c.lastAccessDays <= 2 && (c.sessions || 0) >= 30).length
      const loyal = cards.filter(c => c.lastAccessDays <= 7 && c.lastAccessDays > 2).length
      const atRisk = cards.filter(c => c.cardStatus === 'Em risco' || c.cardStatus === 'Crítico').length
      const inactive = cards.filter(c => c.lastAccessDays >= 30 || c.cardStatus === 'Inativo').length
      const onboarding = cards.filter(c => c.cardStatus === 'Onboarding').length

      return [
        { label: 'Campeões', count: champions, description: 'uso diário, alto engajamento', color: 'green', icon: 'mdi-trophy' },
        { label: 'Leais', count: loyal, description: 'acesso semanal regular', color: 'blue', icon: 'mdi-account-check' },
        { label: 'Em risco', count: atRisk, description: 'queda recente de uso', color: 'orange', icon: 'mdi-alert-outline' },
        { label: 'Inativos', count: inactive, description: 'sem acesso 30d+', color: 'red', icon: 'mdi-account-off' },
        { label: 'Onboarding', count: onboarding, description: 'primeiros acessos', color: 'teal', icon: 'mdi-account-plus' },
      ]
    },

    // Chart: Evolução NPS (line chart)
    npsEvolutionChartData() {
      const evo = this.npsData.evolution || []
      return {
        labels: evo.map(d => d.month),
        datasets: [{
          label: 'NPS',
          data: evo.map(d => d.value),
          borderColor: '#4CAF50',
          backgroundColor: 'rgba(76, 175, 80, 0.1)',
          borderWidth: 2,
          fill: true,
          tension: 0.4,
          pointRadius: 4,
          pointHoverRadius: 6,
          pointBackgroundColor: '#4CAF50',
          pointBorderColor: '#fff',
          pointBorderWidth: 2,
        }],
      }
    },

    npsEvolutionChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#999',
              stepSize: 10,
            },
            gridLines: { color: 'rgba(0,0,0,0.05)' },
          }],
          xAxes: [{
            ticks: { fontColor: '#999' },
            gridLines: { display: false },
          }],
        },
        tooltips: {
          callbacks: {
            label: (t) => `NPS: +${t.yLabel}`,
          },
        },
      }
    },

    // Chart: Horários de pico (bar chart)
    peakHoursChartData() {
      const data = this.engagementPeakHours.length
        ? this.engagementPeakHours.map(d => ({ hour: `${d.hour}h`, value: d.sessions || d.value || 0 }))
        : []
      return {
        labels: data.map(d => d.hour),
        datasets: [{
          label: 'Sessões',
          data: data.map(d => d.value),
          backgroundColor: data.map(d =>
            d.value >= 70 ? '#FFA726' : d.value >= 40 ? '#FFE0B2' : '#FFF3E0'
          ),
          borderColor: data.map(d =>
            d.value >= 70 ? '#F57C00' : d.value >= 40 ? '#FFB74D' : '#FFE0B2'
          ),
          borderWidth: 1,
          barPercentage: 0.7,
          categoryPercentage: 0.9,
        }],
      }
    },

    peakHoursChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#999',
              display: false,
            },
            gridLines: { display: false },
          }],
          xAxes: [{
            ticks: { fontColor: '#999', fontSize: 11 },
            gridLines: { display: false },
          }],
        },
        tooltips: {
          callbacks: {
            label: (t) => `${t.yLabel} sessões`,
          },
        },
      }
    },

    // ====== FINANCEIRO: computed ======

    // Ticket médio (MRR / pagantes)
    finTicketMedio() {
      if (this.payingTenantsCount === 0) return '—'
      return this.formatCurrency(Math.round(this.totalMrr / this.payingTenantsCount))
    },

    // LTV Estimado (ticket médio × 24 meses como proxy)
    finLtvEstimado() {
      if (!this.finHealthData || !this.finHealthData.ltvEstimado) {
        if (this.payingTenantsCount === 0) return '—'
        return this.formatCurrency(Math.round(this.totalMrr / this.payingTenantsCount * 24))
      }
      return this.formatCurrency(this.finHealthData.ltvEstimado)
    },

    // Tabela: Receita por tenant (dados reais de tenantCards + financeByTenantData)
    finRevenueByTenantTable() {
      const mrrMap = {}
      this.financeByTenantData.forEach(f => {
        const name = (f.tenant || '').toLowerCase()
        mrrMap[name] = (mrrMap[name] || 0) + (f.value || 0)
      })

      return this.tenantCards.map(t => {
        const name = (t.name || '').toLowerCase()
        const mrr = mrrMap[name] != null ? mrrMap[name] : (t.monthlyValue || 0)
        const status = (t.status || '').toUpperCase()
        const plan = t.plan || 'Free'

        let statusLabel = 'Ativo'
        let statusColor = 'green lighten-4'
        let statusTextColor = 'green darken-2'
        if (status === 'SUSPENDED') { statusLabel = 'Inativo'; statusColor = 'grey lighten-3'; statusTextColor = 'grey darken-1' }
        else if (status === 'TRIAL') { statusLabel = 'Trial'; statusColor = 'orange lighten-4'; statusTextColor = 'orange darken-3' }
        else if (status === 'CHURNED' || t.cardStatus === 'Inativo') { statusLabel = 'Churn'; statusColor = 'red lighten-4'; statusTextColor = 'red darken-2' }

        return { name: t.name || 'Sem nome', plan, mrr, statusLabel, statusColor, statusTextColor }
      }).sort((a, b) => b.mrr - a.mrr)
    },

    // Distribuição por plano (doughnut)
    finPlanDistribution() {
      const counts = { 'Free / Trial': 0, Starter: 0, Pro: 0, Enterprise: 0 }
      const colors = { 'Free / Trial': '#9E9E9E', Starter: '#4CAF50', Pro: '#2196F3', Enterprise: '#F44336' }

      this.tenantCards.forEach(t => {
        const plan = (t.plan || '').toUpperCase()
        if (plan === 'ENTERPRISE') counts.Enterprise++
        else if (plan === 'PRO' || plan === 'STANDARD') counts.Pro++
        else if (plan === 'STARTER') counts.Starter++
        else counts['Free / Trial']++
      })

      return Object.entries(counts).map(([label, count]) => ({
        label, count, color: colors[label],
      }))
    },

    // Doughnut chart data: Distribuição por plano
    finPlanDistChartData() {
      const dist = this.finPlanDistribution
      return {
        labels: dist.map(d => d.label),
        datasets: [{
          data: dist.map(d => d.count),
          backgroundColor: dist.map(d => d.color),
          borderWidth: 2,
          borderColor: '#fff',
        }],
      }
    },

    finPlanDistChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        cutoutPercentage: 65,
        tooltips: {
          callbacks: {
            label: (t, data) => {
              const label = data.labels[t.index]
              const value = data.datasets[0].data[t.index]
              return `${label}: ${value} tenants`
            },
          },
        },
      }
    },

    // MRR Evolution + Projeção (dados reais + projeção dashed)
    finMrrProjectionChartData() {
      const real = this.mrrMonthlyData.length ? this.mrrMonthlyData : []
      const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']

      // Dados reais
      const realLabels = real.map(d => d.month)
      const realValues = real.map(d => d.value || 0)

      // Projeção: extrapola últimos 2 pontos até Dez
      let projLabels = []
      let projValues = []
      if (realValues.length >= 2) {
        const lastVal = realValues[realValues.length - 1]
        const prevVal = realValues[realValues.length - 2]
        const growth = lastVal > 0 ? (lastVal - prevVal) / Math.max(prevVal, 1) : 0.1

        // Encontrar mês de partida da projeção
        const lastMonth = realLabels[realLabels.length - 1]
        const lastIdx = months.findIndex(m => lastMonth.toLowerCase().startsWith(m.toLowerCase()))
        if (lastIdx >= 0) {
          // Ponto de conexão
          projLabels.push(realLabels[realLabels.length - 1])
          projValues.push(lastVal)
          let val = lastVal
          for (let i = lastIdx + 1; i < 12; i++) {
            val = Math.round(val * (1 + growth))
            projLabels.push(months[i])
            projValues.push(val)
          }
        }
      }

      // Combinar labels únicos
      const allLabels = [...new Set([...realLabels, ...projLabels])]

      return {
        labels: allLabels,
        datasets: [
          {
            label: 'Real',
            data: allLabels.map(l => {
              const idx = realLabels.indexOf(l)
              return idx >= 0 ? realValues[idx] : null
            }),
            borderColor: '#4CAF50',
            backgroundColor: 'rgba(76, 175, 80, 0.15)',
            borderWidth: 2,
            fill: true,
            tension: 0.4,
            pointRadius: 3,
            pointBackgroundColor: '#4CAF50',
            spanGaps: false,
          },
          {
            label: 'Projetado',
            data: allLabels.map(l => {
              const idx = projLabels.indexOf(l)
              return idx >= 0 ? projValues[idx] : null
            }),
            borderColor: '#90CAF9',
            backgroundColor: 'rgba(144, 202, 249, 0.1)',
            borderWidth: 2,
            borderDash: [6, 4],
            fill: true,
            tension: 0.4,
            pointRadius: 0,
            spanGaps: false,
          },
        ],
      }
    },

    finMrrProjectionChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: 'bottom',
          labels: { boxWidth: 12, padding: 20, fontColor: '#666' },
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#999',
              callback: (v) => v >= 1000 ? `${(v / 1000).toFixed(0)}k` : `${v}`,
            },
            gridLines: { color: 'rgba(0,0,0,0.05)' },
          }],
          xAxes: [{
            ticks: { fontColor: '#999' },
            gridLines: { display: false },
          }],
        },
        tooltips: {
          callbacks: {
            label: (t, data) => {
              const dsLabel = data.datasets[t.datasetIndex].label
              return `${dsLabel}: R$ ${Number(t.yLabel).toLocaleString('pt-BR')}`
            },
          },
        },
      }
    },

    // Churn Rate Mensal (bar chart) — dados reais do endpoint
    finChurnBarChartData() {
      const data = this.finChurnMonthly
      return {
        labels: data.map(d => d.month),
        datasets: [{
          label: 'Churn %',
          data: data.map(d => d.value || d.churnRate || 0),
          backgroundColor: '#E53935',
          borderColor: '#C62828',
          borderWidth: 1,
          barPercentage: 0.6,
          categoryPercentage: 0.8,
        }],
      }
    },

    finChurnBarChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontColor: '#999',
              callback: (v) => `${v}%`,
            },
            gridLines: { color: 'rgba(0,0,0,0.05)' },
          }],
          xAxes: [{
            ticks: { fontColor: '#999' },
            gridLines: { display: false },
          }],
        },
      }
    },

    // Faturas Recentes
    finRecentInvoices() {
      return this.finInvoices.map(inv => {
        const status = (inv.status || '').toUpperCase()
        let statusLabel = status
        let statusColor = 'grey lighten-3'
        let statusTextColor = 'grey darken-1'
        if (status === 'PAID' || status === 'PAGO') { statusLabel = 'Pago'; statusColor = 'green lighten-4'; statusTextColor = 'green darken-2' }
        else if (status === 'PENDING' || status === 'PENDENTE') { statusLabel = 'Pendente'; statusColor = 'orange lighten-4'; statusTextColor = 'orange darken-3' }
        else if (status === 'OVERDUE' || status === 'ATRASADO') { statusLabel = 'Atrasado'; statusColor = 'red lighten-4'; statusTextColor = 'red darken-2' }

        return {
          id: inv.id || inv.invoiceId,
          tenant: inv.tenant || inv.tenantName,
          amount: inv.amount || inv.value || 0,
          statusLabel,
          statusColor,
          statusTextColor,
          date: inv.date || inv.createdAt || '—',
        }
      })
    },
  },

  watch: {
    activeTab(val) {
      // Tab 5 = Demos (0: Geral, 1: Tenants, 2: Engajamento, 3: Financeiro, 4: Alertas, 5: Demos)
      if (val === 5 && this.demoRequests.length === 0) {
        this.loadDemoRequests()
        this.loadDemoAnalytics()
      }
    },
  },

  async mounted() {
    await this.loadDashboardData()
  },

  methods: {
    // === CARREGAR DADOS ===
    async loadDashboardData() {
      await Promise.all([
        this.loadStats(),
        this.loadTenants(),
        this.loadAlerts(),
        this.loadFinanceByTenant(),
        this.loadTenantMetadata(),
        this.loadDemoRequests(),
        this.loadDemoAnalytics(),
        this.loadUsersMonthly(),
        this.loadConversion(),
        this.loadRecentActivity(),
        this.loadHealthScores(),
        this.loadTenantActivity(),
        this.loadEngagementSummary(),
        this.loadEngagementFeatures(),
        this.loadEngagementNps(),
        this.loadEngagementPeakHours(),
        this.loadEngagementTopUsers(),
        this.loadFinanceHealth(),
        this.loadFinanceChurnMonthly(),
        this.loadFinanceInvoices(),
      ])
      await this.loadCharts()
    },

    async loadStats() {
      this.loadingStats = true
      try {
        const response = await PlatformService.getStats()
        const data = response.data

        this.stats = {
          activeTenants: data.totalTenants || 0,
          totalUsers: data.totalUsers || 0,
          mrr: data.mrr || 0,
          trialTenants: data.trialTenants || 0,
        }
      } catch (error) {
        console.error('Erro ao carregar estatísticas:', error)
        // Mock fallback
        this.stats = {
          activeTenants: 4,
          totalUsers: 138,
          mrr: 33300,
          trialTenants: 1,
        }
      } finally {
        this.loadingStats = false
      }
    },

    async loadCharts() {
      this.loadingCharts = true
      try {
        // Usuários por tenant
        const byTenantResponse = await PlatformService.getUsersByTenant()
        this.usersByTenantData = byTenantResponse.data.map(item => ({
          tenantId: item.tenantId,
          tenantName: item.tenantName,
          userCount: item.userCount,
        }))

        // Tenants por mês
        try {
          const monthlyResponse = await PlatformService.getTenantsMonthly()
          this.tenantsMonthlyData = monthlyResponse.data
        } catch {
          this.tenantsMonthlyData = this.getMockTenantsMonthly()
        }

        // MRR mensal — usa endpoint real, fallback para mock
        try {
          const mrrResponse = await PlatformService.getMrrMonthly()
          this.mrrMonthlyData = mrrResponse.data
        } catch {
          this.mrrMonthlyData = this.getMockMrrMonthly()
        }
      } catch (error) {
        console.error('Erro ao carregar gráficos:', error)
        this.tenantsMonthlyData = this.getMockTenantsMonthly()
        this.usersByTenantData = this.getMockUsersByTenant()
        this.mrrMonthlyData = this.getMockMrrMonthly()
      } finally {
        this.loadingCharts = false
      }
    },

    async loadTenants() {
      this.loadingTable = true
      try {
        const response = await TenantsService.list()
        this.tenants = response.data.map(tenant => ({
          ...tenant,
          userCount: tenant.userCount || 0,
          maxUsers: tenant.maxUsers || 25,
          subscriptionExpiresAt: tenant.subscriptionExpiresAt || null,
          plan: tenant.plan || 'STANDARD',
          inviteStatus: tenant.inviteStatus || 'ACCEPTED',
          monthlyValue: tenant.monthlyValue || 0,
          adminEmail: tenant.adminEmail || '',
        }))
      } catch (error) {
        console.error('Erro ao carregar tenants:', error)
        // Mock data matching screenshot
        this.tenants = [
          { id: '1', name: 'System Admin Tenant', adminEmail: 'roberto@systemadmin.com', userCount: 19, maxUsers: 50, inviteStatus: 'ACCEPTED', subscriptionExpiresAt: '2026-03-14', plan: 'ENTERPRISE', status: 'ACTIVE', monthlyValue: 4750 },
          { id: '2', name: 'Client Company B', adminEmail: 'fernanda@companyb.com', userCount: 9, maxUsers: 25, inviteStatus: 'ACCEPTED', subscriptionExpiresAt: '2026-02-28', plan: 'STANDARD', status: 'ACTIVE', monthlyValue: 1800 },
          { id: '3', name: 'Tech Solutions Inc', adminEmail: 'carlos@techsolutions.com', userCount: 35, maxUsers: 100, inviteStatus: 'ACCEPTED', subscriptionExpiresAt: '2026-03-09', plan: 'ENTERPRISE', status: 'ACTIVE', monthlyValue: 8750 },
          { id: '4', name: 'Startup Alpha', adminEmail: 'julia@startupalpha.com', userCount: 3, maxUsers: 10, inviteStatus: 'PENDING', subscriptionExpiresAt: '2026-02-19', plan: 'STARTER', status: 'TRIAL', monthlyValue: 0 },
          { id: '5', name: 'Global Corp', adminEmail: 'andre@globalcorp.com', userCount: 72, maxUsers: 200, inviteStatus: 'ACCEPTED', subscriptionExpiresAt: '2026-02-28', plan: 'ENTERPRISE', status: 'ACTIVE', monthlyValue: 18000 },
          { id: '6', name: 'Digital Agency X', adminEmail: 'mariana@agencyx.com', userCount: 0, maxUsers: 25, inviteStatus: 'EXPIRED', subscriptionExpiresAt: '2026-02-14', plan: 'STANDARD', status: 'SUSPENDED', monthlyValue: 1800 },
        ]
      } finally {
        this.loadingTable = false
      }
    },

    // === CARREGAR DADOS ALERTAS ===
    async loadAlerts() {
      try {
        const [summaryRes, listRes, legacyRes] = await Promise.all([
          PlatformService.getAlertsSummary().catch(() => ({ data: null })),
          PlatformService.getAlertsList().catch(() => ({ data: [] })),
          PlatformService.getAlerts().catch(() => ({ data: [] })),
        ])
        // Summary KPIs
        this.alertsSummaryData = summaryRes.data || null
        // List — normalize enums to lowercase
        const rawList = listRes.data || []
        this.alertsListData = rawList.map(a => ({
          ...a,
          severity: (a.severity || '').toLowerCase(),
          status: (a.status || '').toLowerCase(),
          actions: (a.actions || []).map(act => (typeof act === 'string' ? act.toLowerCase() : act)),
        }))
        // Legacy alertsData for Visão Geral badge
        this.alertsData = legacyRes.data || rawList
        this.alertCount = this.alertsListData.filter(a => a.status !== 'resolved' && a.status !== 'dismissed').length
      } catch (error) {
        console.error('Erro ao carregar alertas:', error)
        this.alertsData = []
        this.alertsListData = []
        this.alertsSummaryData = null
      }
    },

    async resolveAlertBackend(alertId) {
      try {
        await PlatformService.resolveAlert(alertId)
      } catch (error) {
        console.error('Erro ao resolver alerta:', error)
      }
    },

    async dismissAlertBackend(alertId) {
      try {
        await PlatformService.dismissAlert(alertId)
      } catch (error) {
        console.error('Erro ao descartar alerta:', error)
      }
    },

    async generateAlertsManual() {
      this.generatingAlerts = true
      try {
        await PlatformService.generateAlerts()
        await this.loadAlerts()
      } catch (error) {
        console.error('Erro ao gerar alertas:', error)
      } finally {
        this.generatingAlerts = false
      }
    },

    async deleteAlertSingle(alert) {
      const idx = this.alertsListData.indexOf(alert)
      if (idx >= 0) this.alertsListData.splice(idx, 1)
      this.alertCount = this.alertsListData.filter(a => a.status !== 'resolved' && a.status !== 'dismissed').length
      try {
        await PlatformService.deleteAlert(alert.id)
      } catch (error) {
        console.error('Erro ao excluir alerta:', error)
        // Reload to restore state if failed
        await this.loadAlerts()
      }
    },

    clearAllAlerts() {
      this.confirmClearAlertsDialog = true
    },

    async confirmClearAlertsExecute() {
      this.confirmClearAlertsDialog = false
      this.clearingAlerts = true
      try {
        const ids = this.alertsListData.map(a => a.id).filter(Boolean)
        await PlatformService.deleteAllAlerts(ids)
        this.alertsListData = []
        this.alertsSummaryData = null
        this.alertCount = 0
      } catch (error) {
        console.error('Erro ao limpar alertas:', error)
      } finally {
        this.clearingAlerts = false
      }
    },

    async loadFinanceByTenant() {
      try {
        const response = await PlatformService.getFinanceByTenant()
        this.financeByTenantData = response.data || []
      } catch (error) {
        console.error('Erro ao carregar finance by tenant:', error)
        this.financeByTenantData = []
      }
    },

    async loadTenantMetadata() {
      try {
        const response = await PlatformService.getTenantMetadata()
        this.tenantMetadata = (response.data || []).filter(t => t.companyName !== 'Unknown')
      } catch (error) {
        console.error('Erro ao carregar tenant metadata:', error)
        this.tenantMetadata = []
      }
    },

    async loadUsersMonthly() {
      try {
        const response = await PlatformService.getUsersMonthly()
        this.usersMonthlyData = response.data || []
      } catch (error) {
        console.error('Erro ao carregar users monthly:', error)
        this.usersMonthlyData = []
      }
    },

    async loadConversion() {
      try {
        const response = await PlatformService.getConversion()
        this.conversionData = response.data || null
      } catch (error) {
        console.error('Erro ao carregar conversion:', error)
        this.conversionData = null
      }
    },

    async loadRecentActivity() {
      try {
        const response = await PlatformService.getRecentActivity()
        this.recentActivityData = response.data || []
      } catch (error) {
        console.error('Erro ao carregar recent activity:', error)
        this.recentActivityData = []
      }
    },

    async loadHealthScores() {
      try {
        const response = await PlatformService.getHealthScores()
        this.healthScoresData = response.data || []
      } catch (error) {
        console.error('Erro ao carregar health scores:', error)
        this.healthScoresData = []
      }
    },

    async loadTenantActivity() {
      try {
        const response = await PlatformService.getTenantActivity()
        this.tenantActivityData = response.data || []
      } catch (error) {
        console.error('Erro ao carregar tenant activity:', error)
        this.tenantActivityData = []
      }
    },

    async syncMetadata() {
      this.syncingMetadata = true
      try {
        await PlatformService.syncTenantMetadata()
        // Recarrega os dados atualizados após o sync
        await Promise.all([
          this.loadTenantMetadata(),
          this.loadTenantActivity(),
        ])
        await this.loadCharts()
      } catch (error) {
        console.error('Erro ao sincronizar metadados:', error)
      } finally {
        this.syncingMetadata = false
      }
    },

    // === CARREGAR DADOS ENGAJAMENTO ===
    async loadEngagementSummary() {
      try {
        const response = await PlatformService.getEngagementSummary()
        this.engagementSummary = response.data || null
      } catch (error) {
        console.error('Erro ao carregar engagement summary:', error)
        this.engagementSummary = null
      }
    },

    async loadEngagementFeatures() {
      try {
        const response = await PlatformService.getEngagementFeatures()
        this.engagementFeatures = response.data || []
      } catch (error) {
        console.error('Erro ao carregar engagement features:', error)
        this.engagementFeatures = []
      }
    },

    async loadEngagementNps() {
      try {
        const response = await PlatformService.getEngagementNps()
        this.engagementNps = response.data || null
      } catch (error) {
        console.error('Erro ao carregar engagement NPS:', error)
        this.engagementNps = null
      }
    },

    async loadEngagementPeakHours() {
      try {
        const response = await PlatformService.getEngagementPeakHours()
        this.engagementPeakHours = response.data || []
      } catch (error) {
        console.error('Erro ao carregar engagement peak hours:', error)
        this.engagementPeakHours = []
      }
    },

    async loadEngagementTopUsers() {
      try {
        const response = await PlatformService.getEngagementTopUsers(10)
        this.engagementTopUsers = response.data || []
      } catch (error) {
        console.error('Erro ao carregar engagement top users:', error)
        this.engagementTopUsers = []
      }
    },

    // === CARREGAR DADOS FINANCEIRO ===
    async loadFinanceHealth() {
      try {
        const response = await PlatformService.getFinanceHealth()
        this.finHealthData = response.data || null
      } catch (error) {
        console.error('Erro ao carregar finance health:', error)
        this.finHealthData = null
      }
    },

    async loadFinanceChurnMonthly() {
      try {
        const response = await PlatformService.getFinanceChurnMonthly()
        this.finChurnMonthly = response.data || []
      } catch (error) {
        console.error('Erro ao carregar churn monthly:', error)
        this.finChurnMonthly = []
      }
    },

    async loadFinanceInvoices() {
      try {
        const response = await PlatformService.getFinanceInvoices()
        this.finInvoices = response.data || []
      } catch (error) {
        console.error('Erro ao carregar invoices:', error)
        this.finInvoices = []
      }
    },

    // === MOCK DATA ===
    getMockTenantsMonthly() {
      return [
        { month: 'Ago.', count: 0 },
        { month: 'Set.', count: 1 },
        { month: 'Out.', count: 1 },
        { month: 'Nov.', count: 0 },
        { month: 'Dez.', count: 0 },
        { month: 'Jan.', count: 2 },
        { month: 'Fev.', count: 1 },
      ]
    },

    getMockUsersByTenant() {
      return [
        { tenantId: '1', tenantName: 'System Admin Tena...', userCount: 19 },
        { tenantId: '2', tenantName: 'Client Company B', userCount: 9 },
        { tenantId: '3', tenantName: 'Tech Solutions Inc', userCount: 35 },
        { tenantId: '4', tenantName: 'Startup Alpha', userCount: 3 },
        { tenantId: '5', tenantName: 'Global Corp', userCount: 72 },
      ]
    },

    getMockMrrMonthly() {
      return [
        { month: 'Ago.', value: 8500 },
        { month: 'Set.', value: 9200 },
        { month: 'Out.', value: 10800 },
        { month: 'Nov.', value: 11500 },
        { month: 'Dez.', value: 12000 },
        { month: 'Jan.', value: 28000 },
        { month: 'Fev.', value: 33300 },
      ]
    },

    // === HELPERS ===
    formatCurrency(value) {
      if (!value && value !== 0) return 'R$ 0'
      return `R$ ${Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 0 })}`
    },

    // Helpers: Visão Geral — Churn & Health
    getChurnDotColor(status) {
      const map = { 'Crítico': '#F44336', 'Atenção': '#FF9800', 'Saudável': '#4CAF50', 'Inativo': '#9E9E9E' }
      return map[status] || '#9E9E9E'
    },
    getChurnChipColor(status) {
      const map = { 'Crítico': 'red', 'Atenção': 'orange lighten-4', 'Saudável': 'green lighten-4', 'Inativo': 'grey lighten-3' }
      return map[status] || 'grey lighten-3'
    },
    getHealthColor(score) {
      if (score >= 70) return '#4CAF50'
      if (score >= 40) return '#FF9800'
      return '#F44336'
    },

    formatDate(dateString) {
      if (!dateString) return '-'
      const date = new Date(dateString)
      return date.toLocaleDateString('pt-BR')
    },

    getTenantColor(name) {
      if (!name) return 'grey'
      const colors = ['primary', 'success', 'info', 'warning', 'error', 'purple', 'teal', 'orange']
      const index = name.charCodeAt(0) % colors.length
      return colors[index]
    },

    getTenantInitials(name) {
      if (!name) return '?'
      const parts = name.split(' ')
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase()
      }
      return name.substring(0, 2).toUpperCase()
    },

    getTenantCardStatusColor(status) {
      const map = {
        'Ativo': 'green lighten-4',
        'Onboarding': 'amber lighten-4',
        'Em risco': 'orange lighten-4',
        'Inativo': 'grey lighten-2',
        'Crítico': 'red lighten-4',
      }
      return map[status] || 'grey lighten-3'
    },

    getTenantCardStatusTextColor(status) {
      const map = {
        'Ativo': 'green darken-3',
        'Onboarding': 'amber darken-4',
        'Em risco': 'orange darken-3',
        'Inativo': 'grey darken-2',
        'Crítico': 'red darken-3',
      }
      return map[status] || 'grey darken-2'
    },

    getInviteColor(status) {
      const map = { ACCEPTED: 'green lighten-4', PENDING: 'orange lighten-4', EXPIRED: 'red lighten-4' }
      return map[status] || 'grey lighten-3'
    },

    getInviteTextColor(status) {
      const map = { ACCEPTED: 'green darken-3', PENDING: 'orange darken-3', EXPIRED: 'red darken-3' }
      return map[status] || 'grey darken-2'
    },

    getInviteLabel(status) {
      const map = { ACCEPTED: 'Aceito', PENDING: 'Pendente', EXPIRED: 'Expirado' }
      return map[status] || status || '-'
    },

    getPlanChipColor(plan) {
      const map = { ENTERPRISE: 'blue lighten-4', STANDARD: 'grey lighten-3', STARTER: 'orange lighten-4' }
      return map[plan] || 'grey lighten-3'
    },

    getPlanChipTextColor(plan) {
      const map = { ENTERPRISE: 'blue darken-3', STANDARD: 'grey darken-2', STARTER: 'orange darken-3' }
      return map[plan] || 'grey darken-2'
    },

    getStatusColor(status) {
      const map = { ACTIVE: 'success', TRIAL: 'amber darken-1', SUSPENDED: 'orange darken-1', INACTIVE: 'grey' }
      return map[status] || 'grey'
    },

    getStatusLabel(status) {
      const map = { ACTIVE: 'Ativo', TRIAL: 'Trial', SUSPENDED: 'Suspenso', INACTIVE: 'Inativo' }
      return map[status] || status || '-'
    },

    getScoreColor(score) {
      if (score >= 80) return '#4CAF50'
      if (score >= 60) return '#FF9800'
      if (score >= 40) return '#FF5722'
      return '#F44336'
    },

    getRiskColor(risk) {
      const map = { Baixo: 'green lighten-4', 'Médio': 'orange lighten-4', Alto: 'red lighten-4' }
      return map[risk] || 'grey lighten-3'
    },

    getRiskTextColor(risk) {
      const map = { Baixo: 'green darken-3', 'Médio': 'orange darken-3', Alto: 'red darken-3' }
      return map[risk] || 'grey darken-2'
    },

    // Alertas helpers (novo layout)
    alertsFilteredCount(filter) {
      if (filter === 'open') return this.alertsListData.filter(a => a.severity === 'critical' && a.status !== 'resolved' && a.status !== 'dismissed').length
      if (filter === 'moderate') return this.alertsListData.filter(a => a.severity === 'moderate' && a.status !== 'resolved' && a.status !== 'dismissed').length
      if (filter === 'resolved') return this.alertsListData.filter(a => a.status === 'resolved').length
      return this.alertsListData.length
    },

    getAlertBorderColor(severity) {
      const map = { critical: '#E53935', moderate: '#FB8C00', resolved: '#43A047' }
      return map[severity] || '#BDBDBD'
    },

    getAlertCardBg(severity) {
      const map = { critical: '#FFF5F5', moderate: '#FFFAF0', resolved: '#F5FFF5' }
      return map[severity] || '#FAFAFA'
    },

    getAlertIconNew(severity) {
      const map = { critical: 'mdi-alert-circle-outline', moderate: 'mdi-alert-outline', resolved: 'mdi-check-circle-outline' }
      return map[severity] || 'mdi-information-outline'
    },

    getAlertIconColorNew(severity) {
      const map = { critical: '#E53935', moderate: '#FB8C00', resolved: '#43A047' }
      return map[severity] || '#9E9E9E'
    },

    getAlertSeverityChipColor(severity) {
      const map = { critical: 'red lighten-4', moderate: 'orange lighten-4', resolved: 'green lighten-4' }
      return map[severity] || 'grey lighten-3'
    },

    getAlertSeverityChipTextColor(severity) {
      const map = { critical: 'red darken-2', moderate: 'orange darken-3', resolved: 'green darken-2' }
      return map[severity] || 'grey darken-1'
    },

    getAlertSeverityLabelNew(severity) {
      const map = { critical: 'Crítico', moderate: 'Moderado', resolved: 'Resolvido' }
      return map[severity] || severity
    },

    getAlertActionColor(severity) {
      const map = { critical: '#E53935', moderate: '#FB8C00', resolved: '#43A047' }
      return map[severity] || '#757575'
    },

    getAlertActions(alert) {
      if (!alert.actions || !alert.actions.length) {
        // Default actions based on severity
        if (alert.severity === 'critical') {
          return [
            { label: 'Ignorar', key: 'ignore', color: 'grey darken-1' },
            { label: 'Marcar resolvido', key: 'resolve', color: 'grey darken-2' },
          ]
        }
        if (alert.severity === 'moderate') {
          return [
            { label: 'Ignorar', key: 'ignore', color: 'grey darken-1' },
            { label: 'Marcar resolvido', key: 'resolve', color: 'grey darken-2' },
          ]
        }
        return []
      }
      const actionMap = {
        ignore: { label: 'Ignorar', color: 'grey darken-1' },
        resolve: { label: 'Marcar resolvido', color: 'grey darken-2' },
        archive: { label: 'Arquivar tenant', color: 'grey darken-1' },
      }
      return alert.actions.map(key => ({ key, ...(actionMap[key] || { label: key, color: 'grey' }) }))
    },

    alertTimeAgo(dateStr) {
      if (!dateStr) return ''
      const diff = Date.now() - new Date(dateStr).getTime()
      const hours = Math.floor(diff / (1000 * 60 * 60))
      if (hours < 1) return 'agora'
      if (hours < 24) return `há ${hours}h`
      const days = Math.floor(hours / 24)
      if (days === 0) return 'hoje'
      if (days === 1) return 'há 1 dia'
      return `há ${days} dias`
    },

    handleAlertAction(alert, actionKey) {
      if (actionKey === 'resolve' || actionKey === 'archive') {
        alert.status = 'resolved'
        alert.severity = 'resolved'
        alert.resolvedAt = new Date().toISOString()
        this.resolveAlertBackend(alert.id)
      } else if (actionKey === 'ignore') {
        const idx = this.alertsListData.indexOf(alert)
        if (idx >= 0) this.alertsListData.splice(idx, 1)
        this.dismissAlertBackend(alert.id)
      }
      // Update badge count
      this.alertCount = this.alertsListData.filter(a => a.status !== 'resolved' && a.status !== 'dismissed').length
    },

    // === TENANT ACTIONS ===
    viewTenant(tenant) {
      if (tenant && tenant.id) {
        this.$router.push(`/tenants/${tenant.id}`)
      }
    },

    resendInvite(tenant) {
      console.log('Reenviar convite:', tenant)
    },

    toggleTenantStatus(tenant) {
      console.log('Toggle status:', tenant)
    },

    // === NOVO TENANT ===
    selectPlan(planValue) {
      this.newTenant.plan = planValue
      
      // Ajustar maxUsers baseado no plano selecionado
      const defaults = {
        STARTER: 10,
        STANDARD: 50,
        ENTERPRISE: 250,
      }
      
      this.newTenant.maxUsers = defaults[planValue] || 10
    },

    closeNewTenantDialog() {
      this.showNewTenantDialog = false
      this.newTenant = {
        name: '',
        plan: 'STARTER',
        maxUsers: 10,
        adminName: '',
        adminEmail: '',
        razaoSocial: '',
        nomeFantasia: '',
        cnpj: '',
        setor: '',
        telefone: '',
        email: '',
        endereco: '',
        website: '',
        porteEmpresa: '',
      }
      this.newTenantStep = 1
      this.createTenantError = ''
      this.createdTenant = null
      this.selectedTenantFile = null
      this.previewTenantAvatar = null
      this.uploadingTenantAvatar = false
      this.newTenantImageToCrop = null
      this.newTenantAvatarBlob = null
      this.newTenantShowCropPreview = false
      this.newTenantCropDialogStep1 = false
      this.newTenantFaviconFile = null
      this.newTenantPreviewFavicon = null
      this.uploadingNewTenantFavicon = false
      if (this.newTenantCropper) {
        this.newTenantCropper.destroy()
        this.newTenantCropper = null
      }
    },

    async createTenant() {
      if (!this.isNewTenantValid) return

      this.createTenantError = ''
      this.creatingTenant = true
      try {
        // 1. Criar tenant sem avatar
        const response = await TenantsService.create({
          name: this.newTenant.name,
          plan: this.newTenant.plan,
          maxUsers: this.newTenant.maxUsers,
          adminName: this.newTenant.adminName,
          adminEmail: this.newTenant.adminEmail,
          companyData: {
            razaoSocial: this.newTenant.razaoSocial || null,
            nomeFantasia: this.newTenant.nomeFantasia || null,
            cnpj: this.newTenant.cnpj || null,
            setor: this.newTenant.setor || null,
            telefone: this.newTenant.telefone || null,
            email: this.newTenant.email || null,
            endereco: this.newTenant.endereco || null,
            website: this.newTenant.website || null,
            porteEmpresa: this.newTenant.porteEmpresa || null,
          },
        })

        this.createdTenant = response.data || response

        // 2. Se tiver avatar em memória, fazer upload automático
        if (this.newTenantAvatarBlob && this.createdTenant.id) {
          this.uploadingTenantAvatar = true
          try {
            const croppedFile = new File([this.newTenantAvatarBlob], 'tenant-logo.jpg', {
              type: 'image/jpeg',
              lastModified: Date.now(),
            })
            
            const res = await TenantAvatarService.uploadAvatar(croppedFile, this.createdTenant.id)
            const avatarUrl = res.data
            this.previewTenantAvatar = avatarUrl
            this.createdTenant.avatarUrl = avatarUrl
          } catch (err) {
            console.error('Erro ao enviar avatar do tenant:', err)
          } finally {
            this.uploadingTenantAvatar = false
          }
        }

        // 2b. Se tiver favicon em memória, fazer upload automático
        if (this.newTenantFaviconFile && this.createdTenant.id) {
          this.uploadingNewTenantFavicon = true
          try {
            const res = await TenantAvatarService.uploadFavicon(this.newTenantFaviconFile, this.createdTenant.id)
            const faviconUrl = res.data
            this.newTenantPreviewFavicon = faviconUrl
            this.createdTenant.logoUrl = faviconUrl
          } catch (err) {
            console.error('Erro ao enviar favicon do tenant:', err)
          } finally {
            this.uploadingNewTenantFavicon = false
          }
        }

        // 3. Atualizar tabela e fechar dialog
        await this.loadTenants()
        this.closeNewTenantDialog()
      } catch (error) {
        console.error('Erro ao criar tenant:', error)
        const data = error.response?.data
        if (data?.error === 'EMAIL_ALREADY_IN_USE') {
          this.createTenantError = data.message || `O e-mail informado já está em uso por outro usuário.`
        } else if (data?.message) {
          this.createTenantError = data.message
        } else {
          this.createTenantError = 'Erro ao criar tenant. Tente novamente.'
        }
      } finally {
        this.creatingTenant = false
      }
    },

    // === Upload Avatar do Tenant (Step 1 - Novo Fluxo) ===
    handleTenantFileDrop(e) {
      const files = e.dataTransfer.files
      if (files && files[0]) {
        this.onTenantFileSelectedStep1({ target: { files } })
      }
    },

    onTenantFileSelectedStep1(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return

      if (!file.type.startsWith('image/')) {
        this.$snackbar?.show('Tipo de arquivo inválido. Use JPG, PNG ou WebP.')
        return
      }

      if (file.size > 5 * 1024 * 1024) {
        this.$snackbar?.show('Arquivo muito grande. Máximo 5MB.')
        return
      }

      this.selectedTenantFile = file

      // Gerar preview para o cropper
      const reader = new FileReader()
      reader.onload = (ev) => {
        this.newTenantImageToCrop = ev.target.result
        this.newTenantCropDialogStep1 = true
        
        // Inicializar cropper após o dialog abrir
        this.$nextTick(() => {
          this.initNewTenantCropperStep1()
        })
      }
      reader.readAsDataURL(file)

      // Limpar input
      e.target.value = ''
    },

    initNewTenantCropperStep1() {
      if (this.newTenantCropper) {
        this.newTenantCropper.destroy()
      }

      const image = this.$refs.newTenantCropperImageStep1
      this.newTenantCropper = new Cropper(image, {
        aspectRatio: 1,
        viewMode: 2,
        dragMode: 'move',
        autoCropArea: 0.8,
        restore: false,
        guides: true,
        center: true,
        highlight: true,
        cropBoxMovable: true,
        cropBoxResizable: true,
        toggleDragModeOnDblclick: false,
        minCropBoxWidth: 100,
        minCropBoxHeight: 100,
      })
    },

    cancelNewTenantCropStep1() {
      if (this.newTenantCropper) {
        this.newTenantCropper.destroy()
        this.newTenantCropper = null
      }
      this.newTenantCropDialogStep1 = false
      this.newTenantImageToCrop = null
      this.selectedTenantFile = null
    },

    async confirmNewTenantCropStep1() {
      if (!this.newTenantCropper) return

      const canvas = this.newTenantCropper.getCroppedCanvas({
        width: 500,
        height: 500,
        imageSmoothingQuality: 'high',
      })

      canvas.toBlob((blob) => {
        if (!blob) {
          console.error('Erro ao processar imagem')
          return
        }

        this.newTenantAvatarBlob = blob
        this.previewTenantAvatar = canvas.toDataURL('image/jpeg', 0.9)

        this.newTenantCropDialogStep1 = false
        if (this.newTenantCropper) {
          this.newTenantCropper.destroy()
          this.newTenantCropper = null
        }
        
        this.newTenantShowCropPreview = true
      }, 'image/jpeg', 0.9)
    },

    removeTenantAvatarStep1() {
      this.newTenantAvatarBlob = null
      this.previewTenantAvatar = null
      this.newTenantShowCropPreview = false
      this.selectedTenantFile = null
    },

    // === Favicon do Novo Tenant ===
    onNewTenantFaviconSelected(event) {
      const file = event.target.files[0]
      if (!file) return

      if (!file.type.startsWith('image/')) {
        console.warn('Tipo de arquivo inválido para favicon')
        return
      }

      if (file.size > 2 * 1024 * 1024) {
        console.warn('Arquivo muito grande (máximo 2MB)')
        return
      }

      this.newTenantFaviconFile = file

      // Preview local
      const reader = new FileReader()
      reader.onload = (e) => {
        this.newTenantPreviewFavicon = e.target.result
      }
      reader.readAsDataURL(file)

      // Limpar input
      event.target.value = ''
    },

    removeNewTenantFavicon() {
      this.newTenantFaviconFile = null
      this.newTenantPreviewFavicon = null
    },

    // === Upload Avatar do Tenant (Wizard passo 2) ===
    triggerTenantFileInput() {
      this.$refs.tenantFileInput && this.$refs.tenantFileInput.click()
    },

    onTenantFileSelected(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return

      if (!file.type.startsWith('image/')) {
        console.warn('Tipo de arquivo inválido')
        return
      }

      if (file.size > 5 * 1024 * 1024) {
        console.warn('Arquivo muito grande (máximo 5MB)')
        return
      }

      this.selectedTenantFile = file

      // Gerar preview para o cropper
      const reader = new FileReader()
      reader.onload = (ev) => {
        this.newTenantImageToCrop = ev.target.result
        this.newTenantCropDialog = true
        
        // Inicializar cropper após o dialog abrir
        this.$nextTick(() => {
          this.initNewTenantCropper()
        })
      }
      reader.readAsDataURL(file)

      // Limpar input
      e.target.value = ''
    },

    initNewTenantCropper() {
      if (this.newTenantCropper) {
        this.newTenantCropper.destroy()
      }

      const image = this.$refs.newTenantCropperImage
      this.newTenantCropper = new Cropper(image, {
        aspectRatio: 1,
        viewMode: 2,
        dragMode: 'move',
        autoCropArea: 0.8,
        restore: false,
        guides: true,
        center: true,
        highlight: true,
        cropBoxMovable: true,
        cropBoxResizable: true,
        toggleDragModeOnDblclick: false,
        minCropBoxWidth: 100,
        minCropBoxHeight: 100,
      })
    },

    cancelNewTenantCrop() {
      if (this.newTenantCropper) {
        this.newTenantCropper.destroy()
        this.newTenantCropper = null
      }
      this.newTenantCropDialog = false
      this.newTenantImageToCrop = null
      this.selectedTenantFile = null
    },

    async confirmNewTenantCrop() {
      if (!this.newTenantCropper || !this.createdTenant) return

      const canvas = this.newTenantCropper.getCroppedCanvas({
        width: 500,
        height: 500,
        imageSmoothingQuality: 'high',
      })

      canvas.toBlob(async (blob) => {
        if (!blob) {
          console.error('Erro ao processar imagem')
          return
        }

        const croppedFile = new File([blob], this.selectedTenantFile.name, {
          type: 'image/jpeg',
          lastModified: Date.now(),
        })

        this.previewTenantAvatar = canvas.toDataURL('image/jpeg', 0.9)

        this.newTenantCropDialog = false
        if (this.newTenantCropper) {
          this.newTenantCropper.destroy()
          this.newTenantCropper = null
        }

        // Fazer upload
        await this.uploadTenantAvatar(croppedFile)
      }, 'image/jpeg', 0.9)
    },

    async uploadTenantAvatar(file) {
      if (!this.createdTenant || !this.createdTenant.id) return
      this.uploadingTenantAvatar = true
      try {
        const res = await TenantAvatarService.uploadAvatar(file, this.createdTenant.id)
        const avatarUrl = res.data
        this.previewTenantAvatar = avatarUrl
        this.createdTenant.avatarUrl = avatarUrl
        await this.loadTenants()
      } catch (err) {
        console.error('Erro ao enviar avatar do tenant:', err)
      } finally {
        this.uploadingTenantAvatar = false
      }
    },

    skipTenantAvatar() {
      // Pula o upload e fecha o wizard
      this.closeNewTenantDialog()
    },

    // === EDIÇÃO DE TENANT ===
    editTenant(tenant) {
      // Navegar para página de detalhes com ?edit=1 para abrir o dialog unificado
      this.$router.push(`/tenants/${tenant.id}?edit=1`)
    },

    selectEditPlan(planValue) {
      this.editTenantData.plan = planValue
      
      // Ajustar maxUsers baseado no plano selecionado
      const defaults = {
        STARTER: 10,
        STANDARD: 50,
        ENTERPRISE: 250,
      }
      
      this.editTenantData.maxUsers = defaults[planValue] || 10
    },

    closeEditTenantDialog() {
      this.showEditTenantDialog = false
      this.editingTenant = null
      this.editTenantData = { name: '', plan: 'STARTER', maxUsers: 10 }
      this.editPreviewAvatar = null
      this.editPreviewFavicon = null
      this.editSelectedFile = null
      this.editImageToCrop = null
      if (this.editCropper) {
        this.editCropper.destroy()
        this.editCropper = null
      }
    },

    async saveTenantEdit() {
      if (!this.editingTenant || !this.editingTenant.id) return
      this.savingTenant = true
      try {
        await TenantsService.update(this.editingTenant.id, {
          name: this.editTenantData.name,
          plan: this.editTenantData.plan,
          maxUsers: this.editTenantData.maxUsers,
        })
        await this.loadTenants()
        this.closeEditTenantDialog()
      } catch (error) {
        console.error('Erro ao salvar tenant:', error)
      } finally {
        this.savingTenant = false
      }
    },

    // === Upload Avatar (Edit Mode) ===
    triggerEditFileInput() {
      this.$refs.editFileInput && this.$refs.editFileInput.click()
    },

    onEditFileSelected(event) {
      const file = event.target.files[0]
      if (!file) return

      if (!file.type.startsWith('image/')) {
        console.warn('Tipo de arquivo inválido')
        return
      }

      if (file.size > 5 * 1024 * 1024) {
        console.warn('Arquivo muito grande (máximo 5MB)')
        return
      }

      this.editSelectedFile = file

      // Gerar preview para o cropper
      const reader = new FileReader()
      reader.onload = (e) => {
        this.editImageToCrop = e.target.result
        this.editCropDialog = true
        
        // Inicializar cropper após o dialog abrir
        this.$nextTick(() => {
          this.initEditCropper()
        })
      }
      reader.readAsDataURL(file)

      // Limpar input
      event.target.value = ''
    },

    initEditCropper() {
      if (this.editCropper) {
        this.editCropper.destroy()
      }

      const image = this.$refs.editCropperImage
      this.editCropper = new Cropper(image, {
        aspectRatio: 1,
        viewMode: 2,
        dragMode: 'move',
        autoCropArea: 0.8,
        restore: false,
        guides: true,
        center: true,
        highlight: true,
        cropBoxMovable: true,
        cropBoxResizable: true,
        toggleDragModeOnDblclick: false,
        minCropBoxWidth: 100,
        minCropBoxHeight: 100,
      })
    },

    cancelEditCrop() {
      if (this.editCropper) {
        this.editCropper.destroy()
        this.editCropper = null
      }
      this.editCropDialog = false
      this.editImageToCrop = null
      this.editSelectedFile = null
    },

    async confirmEditCrop() {
      if (!this.editCropper || !this.editingTenant) return

      const canvas = this.editCropper.getCroppedCanvas({
        width: 500,
        height: 500,
        imageSmoothingQuality: 'high',
      })

      canvas.toBlob(async (blob) => {
        if (!blob) {
          console.error('Erro ao processar imagem')
          return
        }

        const croppedFile = new File([blob], this.editSelectedFile.name, {
          type: 'image/jpeg',
          lastModified: Date.now(),
        })

        this.editPreviewAvatar = canvas.toDataURL('image/jpeg', 0.9)

        this.editCropDialog = false
        if (this.editCropper) {
          this.editCropper.destroy()
          this.editCropper = null
        }

        // Fazer upload
        await this.uploadEditAvatar(croppedFile)
      }, 'image/jpeg', 0.9)
    },

    async uploadEditAvatar(file) {
      if (!this.editingTenant || !this.editingTenant.id) return
      this.uploadingEditAvatar = true
      try {
        const res = await TenantAvatarService.uploadAvatar(file, this.editingTenant.id)
        const avatarUrl = res.data
        this.editPreviewAvatar = avatarUrl
        this.editingTenant.avatarUrl = avatarUrl
        await this.loadTenants()
      } catch (err) {
        console.error('Erro ao enviar avatar do tenant:', err)
      } finally {
        this.uploadingEditAvatar = false
      }
    },

    // === Upload Favicon (Edit Mode) ===
    onEditFaviconSelected(event) {
      const file = event.target.files[0]
      if (!file) return

      if (!file.type.startsWith('image/')) {
        console.warn('Tipo de arquivo inválido para favicon')
        return
      }

      if (file.size > 2 * 1024 * 1024) {
        console.warn('Arquivo muito grande (máximo 2MB)')
        return
      }

      // Preview local imediato
      const reader = new FileReader()
      reader.onload = (e) => {
        this.editPreviewFavicon = e.target.result
      }
      reader.readAsDataURL(file)

      // Upload direto (sem crop para favicon)
      this.uploadEditFavicon(file)

      // Limpar input
      event.target.value = ''
    },

    async uploadEditFavicon(file) {
      if (!this.editingTenant || !this.editingTenant.id) return
      this.uploadingEditFavicon = true
      try {
        const res = await TenantAvatarService.uploadFavicon(file, this.editingTenant.id)
        const faviconUrl = res.data
        this.editPreviewFavicon = faviconUrl
        this.editingTenant.logoUrl = faviconUrl
        await this.loadTenants()
      } catch (err) {
        console.error('Erro ao enviar favicon do tenant:', err)
      } finally {
        this.uploadingEditFavicon = false
      }
    },

    // === DEMO REQUESTS ===
    async loadDemoRequests() {
      this.loadingDemos = true
      try {
        const params = {}
        if (this.demoStatusFilter) params.status = this.demoStatusFilter
        const response = await api.get('/api/public/demo-requests', { params })
        const raw = response.data?.data || response.data || []
        this.demoRequests = raw.map(d => ({
          ...d,
          leadName: d.leadName || d.name,
          leadCreatedAt: d.leadCreatedAt || d.createdAt,
          demoDate: d.demoDate || d.scheduledAt || d.contactedAt,
          leadTimeDays: d.leadTimeDays != null ? Number(d.leadTimeDays) : null,
          resultado: d.resultado || (d.status === 'CONVERTED' ? 'CONVERTIDO' : d.status === 'DISMISSED' ? 'PERDIDO' : null),
        }))
      } catch (error) {
        console.error('Erro ao carregar agenda de demos:', error)
      } finally {
        this.loadingDemos = false
      }
    },

    async loadDemoAnalytics() {
      this.loadingDemoAnalytics = true
      try {
        const response = await api.get('/api/platform/dashboard/demos/analytics')
        this.demoAnalytics = response.data || null
      } catch (error) {
        console.error('Erro ao carregar analytics de demos:', error)
        this.demoAnalytics = null
      } finally {
        this.loadingDemoAnalytics = false
      }
    },

    async updateDemoStatus(item, newStatus) {
      this.updatingDemo = true
      try {
        // Mapeia labels de UI para os valores aceitos pelo back
        const statusMap = {
          REALIZADA: 'CONTACTED',
          CANCELADA: 'DISMISSED',
        }
        const backendStatus = statusMap[newStatus] || newStatus
        await api.put(`/api/public/demo-requests/${item.id}/status`, { status: backendStatus })
        const idx = this.demoRequests.findIndex(d => d.id === item.id)
        if (idx >= 0) this.$set(this.demoRequests, idx, { ...this.demoRequests[idx], status: backendStatus })
      } catch (error) {
        console.error('Erro ao atualizar status:', error)
        await this.loadDemoRequests()
      } finally {
        this.updatingDemo = false
      }
    },

    async updateDemoResultado(item, resultado) {
      this.updatingDemo = true
      try {
        // resultado CONVERTIDO → status CONVERTED; PERDIDO → status DISMISSED
        const statusMap = { CONVERTIDO: 'CONVERTED', PERDIDO: 'DISMISSED' }
        const backendStatus = statusMap[resultado] || resultado
        await api.put(`/api/public/demo-requests/${item.id}/status`, { status: backendStatus })
        const idx = this.demoRequests.findIndex(d => d.id === item.id)
        if (idx >= 0) this.$set(this.demoRequests, idx, { ...this.demoRequests[idx], status: backendStatus, resultado })
      } catch (error) {
        console.error('Erro ao atualizar resultado:', error)
      } finally {
        this.updatingDemo = false
      }
    },

    openDismissDialog(item) {
      this.dismissTarget = item
      this.dismissNotes = ''
      this.showDismissDialog = true
    },

    async confirmDismiss() {
      if (!this.dismissTarget) return
      await this.updateDemoStatus(this.dismissTarget, 'CANCELADA')
      this.showDismissDialog = false
      this.dismissTarget = null
      this.dismissNotes = ''
    },

    formatDemoDate(dateStr) {
      if (!dateStr) return '—'
      const d = new Date(dateStr)
      if (isNaN(d.getTime())) return '—'
      return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
        + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })
    },

    formatDemoDateShort(dateStr) {
      if (!dateStr) return '—'
      const d = new Date(dateStr)
      if (isNaN(d.getTime())) return '—'
      return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },

    getDemoStatusColor(status) {
      const map = {
        PENDING: 'orange lighten-4', CONTACTED: 'blue lighten-4',
        SCHEDULED: 'purple lighten-4', CONVERTED: 'green lighten-4', DISMISSED: 'grey lighten-3',
      }
      return map[status] || 'grey lighten-3'
    },
    getDemoStatusTextColor(status) {
      const map = {
        PENDING: '#E65100', CONTACTED: '#1565C0',
        SCHEDULED: '#6A1B9A', CONVERTED: '#2E7D32', DISMISSED: '#616161',
      }
      return map[status] || '#616161'
    },
    getDemoStatusLabel(status) {
      const map = {
        PENDING: 'Pendente', CONTACTED: 'Contatado',
        SCHEDULED: 'Agendado', CONVERTED: 'Convertido', DISMISSED: 'Dispensado',
      }
      return map[status] || status
    },

    getDemoAgendaStatusColor(status) {
      const map = {
        PENDING: 'blue lighten-4',
        CONTACTED: 'teal lighten-4',
        SCHEDULED: 'blue lighten-4',
        CONVERTED: 'green lighten-4',
        DISMISSED: 'red lighten-5',
      }
      return map[status] || 'grey lighten-3'
    },
    getDemoAgendaStatusTextColor(status) {
      const map = {
        PENDING: '#1565C0',
        CONTACTED: '#00695C',
        SCHEDULED: '#1565C0',
        CONVERTED: '#2E7D32',
        DISMISSED: '#C62828',
      }
      return map[status] || '#616161'
    },
    getDemoAgendaStatusLabel(status) {
      const map = {
        PENDING: 'Agendada',
        CONTACTED: 'Realizada',
        SCHEDULED: 'Agendada',
        CONVERTED: 'Realizada',
        DISMISSED: 'Cancelada',
      }
      return map[status] || status
    },

    getDemoResultadoColor(r) {
      return r === 'CONVERTIDO' ? 'green lighten-4' : 'red lighten-5'
    },
    getDemoResultadoTextColor(r) {
      return r === 'CONVERTIDO' ? '#2E7D32' : '#C62828'
    },
    getDemoResultadoLabel(r) {
      return r === 'CONVERTIDO' ? 'Convertido' : 'Perdido'
    },

    // === NAVEGAÇÃO ===
    goToTenantByName(tenantName) {
      const chartItem = this.mergedUsersByTenant.find(item => item.tenantName === tenantName)
      if (chartItem && chartItem.tenantId) {
        this.$router.push(`/tenants/${chartItem.tenantId}`)
        return
      }
      const tenant = this.tenants.find(t => t.name === tenantName)
      if (tenant) {
        this.$router.push(`/tenants/${tenant.id}`)
      }
    },

    goToSettings() {
      this.$router.push('/settings')
    },

    logout() {
      localStorage.removeItem('firebaseToken')
      localStorage.removeItem('user')
      localStorage.removeItem('tenantId')
      localStorage.removeItem('backendToken')
      this.$router.push('/login')
    },
  },
}
</script>

<style scoped>
#dashboard-owner {
  min-height: 100vh;
  font-family: 'Inter', 'Roboto', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Light */
.theme--light#dashboard-owner,
#dashboard-owner.theme--light {
  background-color: #F5F6F8;
}

/* Dark */
.theme--dark#dashboard-owner,
#dashboard-owner.theme--dark {
  background-color: #0F1117;
}

/* Dashboard Main - Background */
.dashboard-main {
  background-color: inherit !important;
}

.theme--dark .dashboard-main {
  background-color: #0F1117 !important;
}

.theme--light .dashboard-main {
  background-color: #F5F5F7 !important;
}

/* --- Header --- */
#dashboard-owner >>> .v-app-bar {
  border-bottom: 1px solid #E5E5E7 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.theme--dark #dashboard-owner >>> .v-app-bar,
#dashboard-owner.theme--dark >>> .v-app-bar {
  border-bottom: 1px solid #38383A !important;
  background-color: #1C1C1E !important;
}

/* --- KPI Cards --- */
.kpi-card {
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  border: 1px solid #E5E7EB !important;
  border-radius: 12px !important;
}

.kpi-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06) !important;
  transform: translateY(-1px);
}

/* --- Tabs --- */
.owner-tabs .v-tab {
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0;
  font-size: 0.875rem;
  color: #6B7280;
}

.owner-tabs .v-tab--active {
  color: #111827 !important;
  font-weight: 600;
}

/* Dark tabs */
.theme--dark .owner-tabs .v-tab {
  color: #9CA3AF;
}

.theme--dark .owner-tabs .v-tab--active {
  color: #F9FAFB !important;
}

/* Tabs Items Background */
#dashboard-owner >>> .v-tabs-items {
  background-color: transparent !important;
}

.theme--dark #dashboard-owner >>> .v-tabs-items {
  background-color: transparent !important;
}

/* --- Clickable Items --- */
.clickable-item {
  cursor: pointer;
  transition: background-color 0.15s ease;
  border-radius: 8px;
}

.clickable-item:hover {
  background-color: #F9FAFB !important;
}

.theme--dark .clickable-item:hover {
  background-color: #1F2233 !important;
}

/* --- Tables --- */
.tenants-table >>> .v-data-table__wrapper table {
  border-collapse: separate;
  border-spacing: 0 2px;
}

.tenants-table >>> tbody tr {
  transition: background-color 0.15s ease;
}

.tenants-table >>> tbody tr:hover {
  background-color: #FAFBFC;
}

.tenants-table >>> thead th {
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  color: #6B7280 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.health-table >>> thead th {
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  color: #6B7280 !important;
}

.health-table >>> tbody tr:hover {
  background-color: #FAFBFC;
}

/* --- Cards dentro do dashboard --- */
#dashboard-owner .v-card {
  border: 1px solid #E5E7EB;
  border-radius: 12px !important;
  background-color: white !important;
}

/* Dark Card borders */
.theme--dark #dashboard-owner .v-card,
#dashboard-owner.theme--dark .v-card {
  border-color: #2D3140;
  background-color: #1F2233 !important;
}

/* --- Avatars --- */
#dashboard-owner .v-avatar {
  border-radius: 10px !important;
}

/* --- Chips --- */
#dashboard-owner .v-chip {
  border-radius: 6px !important;
  font-weight: 500;
}

/* --- Plan Selection Cards --- */
.plan-selected {
  box-shadow: 0 8px 24px rgba(63, 81, 181, 0.35) !important;
  transform: scale(1.02);
}

.cursor-pointer {
  cursor: pointer;
}

/* --- Avatar Upload --- */
.avatar-clickable {
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.avatar-clickable:hover {
  opacity: 0.85;
}

/* --- Crop Container --- */
.crop-container {
  width: 100%;
  overflow: hidden;
}

.crop-container img {
  display: block;
  max-width: 100%;
}

/* --- Avatar Upload Wrapper --- */
.avatar-upload-wrapper {
  position: relative;
}

.logo-upload-btn {
  position: absolute !important;
  bottom: -2px;
  right: -2px;
  width: 32px !important;
  height: 32px !important;
}

/* --- Edit Dialog --- */
.edit-tenant-dialog .v-card__title {
  border-bottom: 1px solid #E5E7EB;
}

.theme--dark .edit-tenant-dialog .v-card__title {
  border-bottom-color: #2D3140;
}

/* --- Logo Upload Zone (Step 1) --- */
.logo-upload-zone {
  background: linear-gradient(135deg, #F9FAFB 0%, #F3F4F6 100%);
  border: 2px dashed #E5E7EB;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.logo-upload-zone:hover {
  background: linear-gradient(135deg, #F0F2F5 0%, #E8EAED 100%);
  border-color: #D1D5DB;
}

.theme--dark .logo-upload-zone {
  background: linear-gradient(135deg, #2D3140 0%, #262D38 100%);
  border-color: #3F4553;
}

.theme--dark .logo-upload-zone:hover {
  background: linear-gradient(135deg, #38414F 0%, #2D3440 100%);
  border-color: #4A5563;
}

/* --- Demo Lead Time Bars --- */
.demo-lt-track {
  height: 10px;
  background: #F1F3F4;
  border-radius: 6px;
  overflow: hidden;
}
.demo-lt-bar {
  height: 100%;
  border-radius: 6px;
  transition: width 0.5s ease;
}

/* --- Demos Table --- */
.demos-table >>> thead th {
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  color: #6B7280 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.demos-table >>> tbody tr {
  transition: background-color 0.15s ease;
}

.demos-table >>> tbody tr:hover {
  background-color: #FAFBFC;
}

.theme--dark .demos-table >>> tbody tr:hover {
  background-color: #1F2233;
}

/* --- Tenant Cards Grid --- */
.tenant-card {
  position: relative;
  transition: box-shadow 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
}

.tenant-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08) !important;
  transform: translateY(-2px);
}

.tenant-card--risk {
  border-left: 4px solid #FF9800 !important;
}

.tenant-card--critical {
  border-left: 4px solid #F44336 !important;
}

.tenant-card--inactive {
  border-left: 4px solid #9E9E9E !important;
  opacity: 0.85;
}

.tenant-card-actions {
  opacity: 0;
  transition: opacity 0.15s ease;
}

.tenant-card:hover .tenant-card-actions {
  opacity: 1;
}

.tenant-search-field >>> .v-input__slot {
  min-height: 36px !important;
}

.tenant-search-field >>> .v-label {
  font-size: 0.85rem;
}
</style>
